/**
 * @fileoverview gRPC-Web generated client stub for ticketepb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_common_pb = require('../../xcommon/common_pb.js')

var xcommon_ticket_pb = require('../../xcommon/ticket_pb.js')

var xcommon_collection_pb = require('../../xcommon/collection_pb.js')
const proto = {};
proto.ticketepb = require('./ticket_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.ticketepb.TicketServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.ticketepb.TicketServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetBasicTicketAttrsReq,
 *   !proto.xcommon.GetBasicTicketAttrsResp>}
 */
const methodDescriptor_TicketService_GetBasicTicketAttrs = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetBasicTicketAttrs',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetBasicTicketAttrsReq,
  xcommon_ticket_pb.GetBasicTicketAttrsResp,
  /**
   * @param {!proto.xcommon.GetBasicTicketAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetBasicTicketAttrsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetBasicTicketAttrsReq,
 *   !proto.xcommon.GetBasicTicketAttrsResp>}
 */
const methodInfo_TicketService_GetBasicTicketAttrs = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetBasicTicketAttrsResp,
  /**
   * @param {!proto.xcommon.GetBasicTicketAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetBasicTicketAttrsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetBasicTicketAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetBasicTicketAttrsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetBasicTicketAttrsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getBasicTicketAttrs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetBasicTicketAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetBasicTicketAttrs,
      callback);
};


/**
 * @param {!proto.xcommon.GetBasicTicketAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetBasicTicketAttrsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getBasicTicketAttrs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetBasicTicketAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetBasicTicketAttrs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketAttrFuncReq,
 *   !proto.xcommon.GetTicketAttrFuncResp>}
 */
const methodDescriptor_TicketService_GetTicketAttrFunc = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketAttrFunc',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketAttrFuncReq,
  xcommon_ticket_pb.GetTicketAttrFuncResp,
  /**
   * @param {!proto.xcommon.GetTicketAttrFuncReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAttrFuncResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketAttrFuncReq,
 *   !proto.xcommon.GetTicketAttrFuncResp>}
 */
const methodInfo_TicketService_GetTicketAttrFunc = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketAttrFuncResp,
  /**
   * @param {!proto.xcommon.GetTicketAttrFuncReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAttrFuncResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketAttrFuncReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketAttrFuncResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketAttrFuncResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketAttrFunc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAttrFunc',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAttrFunc,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketAttrFuncReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketAttrFuncResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketAttrFunc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAttrFunc',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAttrFunc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketAttrsOptionReq,
 *   !proto.xcommon.GetTicketAttrsOptionResp>}
 */
const methodDescriptor_TicketService_GetTicketAttrsOption = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketAttrsOption',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketAttrsOptionReq,
  xcommon_ticket_pb.GetTicketAttrsOptionResp,
  /**
   * @param {!proto.xcommon.GetTicketAttrsOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAttrsOptionResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketAttrsOptionReq,
 *   !proto.xcommon.GetTicketAttrsOptionResp>}
 */
const methodInfo_TicketService_GetTicketAttrsOption = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketAttrsOptionResp,
  /**
   * @param {!proto.xcommon.GetTicketAttrsOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAttrsOptionResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketAttrsOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketAttrsOptionResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketAttrsOptionResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketAttrsOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAttrsOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAttrsOption,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketAttrsOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketAttrsOptionResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketAttrsOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAttrsOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAttrsOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketAttrsReq,
 *   !proto.xcommon.GetTicketAttrsResp>}
 */
const methodDescriptor_TicketService_GetTicketAttrs = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketAttrs',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketAttrsReq,
  xcommon_ticket_pb.GetTicketAttrsResp,
  /**
   * @param {!proto.xcommon.GetTicketAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAttrsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketAttrsReq,
 *   !proto.xcommon.GetTicketAttrsResp>}
 */
const methodInfo_TicketService_GetTicketAttrs = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketAttrsResp,
  /**
   * @param {!proto.xcommon.GetTicketAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAttrsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketAttrsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketAttrsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketAttrs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAttrs,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketAttrsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketAttrs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAttrs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveTicketAttrReq,
 *   !proto.xcommon.SaveTicketAttrResp>}
 */
const methodDescriptor_TicketService_SaveTicketAttr = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveTicketAttr',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveTicketAttrReq,
  xcommon_ticket_pb.SaveTicketAttrResp,
  /**
   * @param {!proto.xcommon.SaveTicketAttrReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketAttrResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveTicketAttrReq,
 *   !proto.xcommon.SaveTicketAttrResp>}
 */
const methodInfo_TicketService_SaveTicketAttr = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveTicketAttrResp,
  /**
   * @param {!proto.xcommon.SaveTicketAttrReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketAttrResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveTicketAttrReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveTicketAttrResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveTicketAttrResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveTicketAttr =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketAttr',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketAttr,
      callback);
};


/**
 * @param {!proto.xcommon.SaveTicketAttrReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveTicketAttrResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveTicketAttr =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketAttr',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketAttr);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetBasicUserAttrsReq,
 *   !proto.xcommon.GetBasicUserAttrsResp>}
 */
const methodDescriptor_TicketService_GetBasicUserAttrs = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetBasicUserAttrs',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetBasicUserAttrsReq,
  xcommon_ticket_pb.GetBasicUserAttrsResp,
  /**
   * @param {!proto.xcommon.GetBasicUserAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetBasicUserAttrsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetBasicUserAttrsReq,
 *   !proto.xcommon.GetBasicUserAttrsResp>}
 */
const methodInfo_TicketService_GetBasicUserAttrs = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetBasicUserAttrsResp,
  /**
   * @param {!proto.xcommon.GetBasicUserAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetBasicUserAttrsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetBasicUserAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetBasicUserAttrsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetBasicUserAttrsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getBasicUserAttrs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetBasicUserAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetBasicUserAttrs,
      callback);
};


/**
 * @param {!proto.xcommon.GetBasicUserAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetBasicUserAttrsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getBasicUserAttrs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetBasicUserAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetBasicUserAttrs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUserAttrFuncReq,
 *   !proto.xcommon.GetUserAttrFuncResp>}
 */
const methodDescriptor_TicketService_GetUserAttrFunc = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUserAttrFunc',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUserAttrFuncReq,
  xcommon_ticket_pb.GetUserAttrFuncResp,
  /**
   * @param {!proto.xcommon.GetUserAttrFuncReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserAttrFuncResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUserAttrFuncReq,
 *   !proto.xcommon.GetUserAttrFuncResp>}
 */
const methodInfo_TicketService_GetUserAttrFunc = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetUserAttrFuncResp,
  /**
   * @param {!proto.xcommon.GetUserAttrFuncReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserAttrFuncResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUserAttrFuncReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetUserAttrFuncResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUserAttrFuncResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUserAttrFunc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserAttrFunc',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserAttrFunc,
      callback);
};


/**
 * @param {!proto.xcommon.GetUserAttrFuncReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUserAttrFuncResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUserAttrFunc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserAttrFunc',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserAttrFunc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUserAttrsOptionReq,
 *   !proto.xcommon.GetUserAttrsOptionResp>}
 */
const methodDescriptor_TicketService_GetUserAttrsOption = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUserAttrsOption',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUserAttrsOptionReq,
  xcommon_ticket_pb.GetUserAttrsOptionResp,
  /**
   * @param {!proto.xcommon.GetUserAttrsOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserAttrsOptionResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUserAttrsOptionReq,
 *   !proto.xcommon.GetUserAttrsOptionResp>}
 */
const methodInfo_TicketService_GetUserAttrsOption = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetUserAttrsOptionResp,
  /**
   * @param {!proto.xcommon.GetUserAttrsOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserAttrsOptionResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUserAttrsOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetUserAttrsOptionResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUserAttrsOptionResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUserAttrsOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserAttrsOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserAttrsOption,
      callback);
};


/**
 * @param {!proto.xcommon.GetUserAttrsOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUserAttrsOptionResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUserAttrsOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserAttrsOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserAttrsOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUserAttrsReq,
 *   !proto.xcommon.GetUserAttrsResp>}
 */
const methodDescriptor_TicketService_GetUserAttrs = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUserAttrs',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUserAttrsReq,
  xcommon_ticket_pb.GetUserAttrsResp,
  /**
   * @param {!proto.xcommon.GetUserAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserAttrsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUserAttrsReq,
 *   !proto.xcommon.GetUserAttrsResp>}
 */
const methodInfo_TicketService_GetUserAttrs = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetUserAttrsResp,
  /**
   * @param {!proto.xcommon.GetUserAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserAttrsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUserAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetUserAttrsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUserAttrsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUserAttrs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserAttrs,
      callback);
};


/**
 * @param {!proto.xcommon.GetUserAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUserAttrsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUserAttrs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserAttrs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveUserAttrReq,
 *   !proto.xcommon.SaveUserAttrResp>}
 */
const methodDescriptor_TicketService_SaveUserAttr = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveUserAttr',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveUserAttrReq,
  xcommon_ticket_pb.SaveUserAttrResp,
  /**
   * @param {!proto.xcommon.SaveUserAttrReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveUserAttrResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveUserAttrReq,
 *   !proto.xcommon.SaveUserAttrResp>}
 */
const methodInfo_TicketService_SaveUserAttr = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveUserAttrResp,
  /**
   * @param {!proto.xcommon.SaveUserAttrReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveUserAttrResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveUserAttrReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveUserAttrResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveUserAttrResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveUserAttr =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveUserAttr',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveUserAttr,
      callback);
};


/**
 * @param {!proto.xcommon.SaveUserAttrReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveUserAttrResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveUserAttr =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveUserAttr',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveUserAttr);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetBasicLoadAttrsReq,
 *   !proto.xcommon.GetBasicLoadAttrsResp>}
 */
const methodDescriptor_TicketService_GetBasicLoadAttrs = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetBasicLoadAttrs',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetBasicLoadAttrsReq,
  xcommon_ticket_pb.GetBasicLoadAttrsResp,
  /**
   * @param {!proto.xcommon.GetBasicLoadAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetBasicLoadAttrsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetBasicLoadAttrsReq,
 *   !proto.xcommon.GetBasicLoadAttrsResp>}
 */
const methodInfo_TicketService_GetBasicLoadAttrs = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetBasicLoadAttrsResp,
  /**
   * @param {!proto.xcommon.GetBasicLoadAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetBasicLoadAttrsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetBasicLoadAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetBasicLoadAttrsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetBasicLoadAttrsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getBasicLoadAttrs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetBasicLoadAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetBasicLoadAttrs,
      callback);
};


/**
 * @param {!proto.xcommon.GetBasicLoadAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetBasicLoadAttrsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getBasicLoadAttrs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetBasicLoadAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetBasicLoadAttrs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetLoadAttrsOptionReq,
 *   !proto.xcommon.GetLoadAttrsOptionResp>}
 */
const methodDescriptor_TicketService_GetLoadAttrsOption = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetLoadAttrsOption',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetLoadAttrsOptionReq,
  xcommon_ticket_pb.GetLoadAttrsOptionResp,
  /**
   * @param {!proto.xcommon.GetLoadAttrsOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetLoadAttrsOptionResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetLoadAttrsOptionReq,
 *   !proto.xcommon.GetLoadAttrsOptionResp>}
 */
const methodInfo_TicketService_GetLoadAttrsOption = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetLoadAttrsOptionResp,
  /**
   * @param {!proto.xcommon.GetLoadAttrsOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetLoadAttrsOptionResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetLoadAttrsOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetLoadAttrsOptionResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetLoadAttrsOptionResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getLoadAttrsOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetLoadAttrsOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLoadAttrsOption,
      callback);
};


/**
 * @param {!proto.xcommon.GetLoadAttrsOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetLoadAttrsOptionResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getLoadAttrsOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetLoadAttrsOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLoadAttrsOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetLoadAttrsReq,
 *   !proto.xcommon.GetLoadAttrsResp>}
 */
const methodDescriptor_TicketService_GetLoadAttrs = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetLoadAttrs',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetLoadAttrsReq,
  xcommon_ticket_pb.GetLoadAttrsResp,
  /**
   * @param {!proto.xcommon.GetLoadAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetLoadAttrsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetLoadAttrsReq,
 *   !proto.xcommon.GetLoadAttrsResp>}
 */
const methodInfo_TicketService_GetLoadAttrs = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetLoadAttrsResp,
  /**
   * @param {!proto.xcommon.GetLoadAttrsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetLoadAttrsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetLoadAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetLoadAttrsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetLoadAttrsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getLoadAttrs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetLoadAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLoadAttrs,
      callback);
};


/**
 * @param {!proto.xcommon.GetLoadAttrsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetLoadAttrsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getLoadAttrs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetLoadAttrs',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLoadAttrs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveLoadAttrReq,
 *   !proto.xcommon.SaveLoadAttrResp>}
 */
const methodDescriptor_TicketService_SaveLoadAttr = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveLoadAttr',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveLoadAttrReq,
  xcommon_ticket_pb.SaveLoadAttrResp,
  /**
   * @param {!proto.xcommon.SaveLoadAttrReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveLoadAttrResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveLoadAttrReq,
 *   !proto.xcommon.SaveLoadAttrResp>}
 */
const methodInfo_TicketService_SaveLoadAttr = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveLoadAttrResp,
  /**
   * @param {!proto.xcommon.SaveLoadAttrReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveLoadAttrResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveLoadAttrReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveLoadAttrResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveLoadAttrResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveLoadAttr =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveLoadAttr',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveLoadAttr,
      callback);
};


/**
 * @param {!proto.xcommon.SaveLoadAttrReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveLoadAttrResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveLoadAttr =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveLoadAttr',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveLoadAttr);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketAssignParamReq,
 *   !proto.xcommon.GetTicketAssignParamResp>}
 */
const methodDescriptor_TicketService_GetTicketAssignParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketAssignParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketAssignParamReq,
  xcommon_ticket_pb.GetTicketAssignParamResp,
  /**
   * @param {!proto.xcommon.GetTicketAssignParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAssignParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketAssignParamReq,
 *   !proto.xcommon.GetTicketAssignParamResp>}
 */
const methodInfo_TicketService_GetTicketAssignParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketAssignParamResp,
  /**
   * @param {!proto.xcommon.GetTicketAssignParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAssignParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketAssignParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketAssignParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketAssignParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketAssignParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAssignParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAssignParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketAssignParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketAssignParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketAssignParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAssignParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAssignParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketAssignRulesReq,
 *   !proto.xcommon.GetTicketAssignRulesResp>}
 */
const methodDescriptor_TicketService_GetTicketAssignRules = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketAssignRules',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketAssignRulesReq,
  xcommon_ticket_pb.GetTicketAssignRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketAssignRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAssignRulesResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketAssignRulesReq,
 *   !proto.xcommon.GetTicketAssignRulesResp>}
 */
const methodInfo_TicketService_GetTicketAssignRules = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketAssignRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketAssignRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketAssignRulesResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketAssignRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketAssignRulesResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketAssignRulesResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketAssignRules =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAssignRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAssignRules,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketAssignRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketAssignRulesResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketAssignRules =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketAssignRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketAssignRules);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveTicketAssignRuleReq,
 *   !proto.xcommon.SaveTicketAssignRuleResp>}
 */
const methodDescriptor_TicketService_SaveTicketAssignRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveTicketAssignRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveTicketAssignRuleReq,
  xcommon_ticket_pb.SaveTicketAssignRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketAssignRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketAssignRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveTicketAssignRuleReq,
 *   !proto.xcommon.SaveTicketAssignRuleResp>}
 */
const methodInfo_TicketService_SaveTicketAssignRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveTicketAssignRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketAssignRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketAssignRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveTicketAssignRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveTicketAssignRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveTicketAssignRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveTicketAssignRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketAssignRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketAssignRule,
      callback);
};


/**
 * @param {!proto.xcommon.SaveTicketAssignRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveTicketAssignRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveTicketAssignRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketAssignRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketAssignRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DeleteTicketAssignRuleReq,
 *   !proto.xcommon.DeleteTicketAssignRuleResp>}
 */
const methodDescriptor_TicketService_DeleteTicketAssignRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DeleteTicketAssignRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DeleteTicketAssignRuleReq,
  xcommon_ticket_pb.DeleteTicketAssignRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketAssignRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketAssignRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DeleteTicketAssignRuleReq,
 *   !proto.xcommon.DeleteTicketAssignRuleResp>}
 */
const methodInfo_TicketService_DeleteTicketAssignRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DeleteTicketAssignRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketAssignRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketAssignRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DeleteTicketAssignRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DeleteTicketAssignRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DeleteTicketAssignRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.deleteTicketAssignRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketAssignRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketAssignRule,
      callback);
};


/**
 * @param {!proto.xcommon.DeleteTicketAssignRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DeleteTicketAssignRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.deleteTicketAssignRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketAssignRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketAssignRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketRecycleParamReq,
 *   !proto.xcommon.GetTicketRecycleParamResp>}
 */
const methodDescriptor_TicketService_GetTicketRecycleParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketRecycleParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketRecycleParamReq,
  xcommon_ticket_pb.GetTicketRecycleParamResp,
  /**
   * @param {!proto.xcommon.GetTicketRecycleParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecycleParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketRecycleParamReq,
 *   !proto.xcommon.GetTicketRecycleParamResp>}
 */
const methodInfo_TicketService_GetTicketRecycleParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketRecycleParamResp,
  /**
   * @param {!proto.xcommon.GetTicketRecycleParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecycleParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketRecycleParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketRecycleParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketRecycleParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketRecycleParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecycleParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecycleParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketRecycleParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketRecycleParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketRecycleParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecycleParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecycleParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketRecycleRulesReq,
 *   !proto.xcommon.GetTicketRecycleRulesResp>}
 */
const methodDescriptor_TicketService_GetTicketRecycleRules = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketRecycleRules',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketRecycleRulesReq,
  xcommon_ticket_pb.GetTicketRecycleRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketRecycleRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecycleRulesResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketRecycleRulesReq,
 *   !proto.xcommon.GetTicketRecycleRulesResp>}
 */
const methodInfo_TicketService_GetTicketRecycleRules = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketRecycleRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketRecycleRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecycleRulesResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketRecycleRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketRecycleRulesResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketRecycleRulesResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketRecycleRules =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecycleRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecycleRules,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketRecycleRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketRecycleRulesResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketRecycleRules =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecycleRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecycleRules);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveTicketRecycleRuleReq,
 *   !proto.xcommon.SaveTicketRecycleRuleResp>}
 */
const methodDescriptor_TicketService_SaveTicketRecycleRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveTicketRecycleRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveTicketRecycleRuleReq,
  xcommon_ticket_pb.SaveTicketRecycleRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketRecycleRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketRecycleRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveTicketRecycleRuleReq,
 *   !proto.xcommon.SaveTicketRecycleRuleResp>}
 */
const methodInfo_TicketService_SaveTicketRecycleRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveTicketRecycleRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketRecycleRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketRecycleRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveTicketRecycleRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveTicketRecycleRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveTicketRecycleRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveTicketRecycleRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketRecycleRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketRecycleRule,
      callback);
};


/**
 * @param {!proto.xcommon.SaveTicketRecycleRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveTicketRecycleRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveTicketRecycleRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketRecycleRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketRecycleRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DeleteTicketRecycleRuleReq,
 *   !proto.xcommon.DeleteTicketRecycleRuleResp>}
 */
const methodDescriptor_TicketService_DeleteTicketRecycleRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DeleteTicketRecycleRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DeleteTicketRecycleRuleReq,
  xcommon_ticket_pb.DeleteTicketRecycleRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketRecycleRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DeleteTicketRecycleRuleReq,
 *   !proto.xcommon.DeleteTicketRecycleRuleResp>}
 */
const methodInfo_TicketService_DeleteTicketRecycleRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DeleteTicketRecycleRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketRecycleRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DeleteTicketRecycleRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DeleteTicketRecycleRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.deleteTicketRecycleRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketRecycleRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketRecycleRule,
      callback);
};


/**
 * @param {!proto.xcommon.DeleteTicketRecycleRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DeleteTicketRecycleRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.deleteTicketRecycleRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketRecycleRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketRecycleRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketEntrustParamReq,
 *   !proto.xcommon.GetTicketEntrustParamResp>}
 */
const methodDescriptor_TicketService_GetTicketEntrustParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketEntrustParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketEntrustParamReq,
  xcommon_ticket_pb.GetTicketEntrustParamResp,
  /**
   * @param {!proto.xcommon.GetTicketEntrustParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketEntrustParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketEntrustParamReq,
 *   !proto.xcommon.GetTicketEntrustParamResp>}
 */
const methodInfo_TicketService_GetTicketEntrustParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketEntrustParamResp,
  /**
   * @param {!proto.xcommon.GetTicketEntrustParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketEntrustParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketEntrustParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketEntrustParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketEntrustParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketEntrustParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketEntrustParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketEntrustParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketEntrustParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketEntrustParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketEntrustParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketEntrustParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketEntrustParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketEntrustRulesReq,
 *   !proto.xcommon.GetTicketEntrustRulesResp>}
 */
const methodDescriptor_TicketService_GetTicketEntrustRules = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketEntrustRules',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketEntrustRulesReq,
  xcommon_ticket_pb.GetTicketEntrustRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketEntrustRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketEntrustRulesResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketEntrustRulesReq,
 *   !proto.xcommon.GetTicketEntrustRulesResp>}
 */
const methodInfo_TicketService_GetTicketEntrustRules = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketEntrustRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketEntrustRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketEntrustRulesResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketEntrustRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketEntrustRulesResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketEntrustRulesResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketEntrustRules =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketEntrustRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketEntrustRules,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketEntrustRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketEntrustRulesResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketEntrustRules =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketEntrustRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketEntrustRules);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveTicketEntrustRuleReq,
 *   !proto.xcommon.SaveTicketEntrustRuleResp>}
 */
const methodDescriptor_TicketService_SaveTicketEntrustRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveTicketEntrustRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveTicketEntrustRuleReq,
  xcommon_ticket_pb.SaveTicketEntrustRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketEntrustRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketEntrustRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveTicketEntrustRuleReq,
 *   !proto.xcommon.SaveTicketEntrustRuleResp>}
 */
const methodInfo_TicketService_SaveTicketEntrustRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveTicketEntrustRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketEntrustRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketEntrustRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveTicketEntrustRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveTicketEntrustRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveTicketEntrustRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveTicketEntrustRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketEntrustRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketEntrustRule,
      callback);
};


/**
 * @param {!proto.xcommon.SaveTicketEntrustRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveTicketEntrustRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveTicketEntrustRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketEntrustRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketEntrustRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DeleteTicketEntrustRuleReq,
 *   !proto.xcommon.DeleteTicketEntrustRuleResp>}
 */
const methodDescriptor_TicketService_DeleteTicketEntrustRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DeleteTicketEntrustRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DeleteTicketEntrustRuleReq,
  xcommon_ticket_pb.DeleteTicketEntrustRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketEntrustRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DeleteTicketEntrustRuleReq,
 *   !proto.xcommon.DeleteTicketEntrustRuleResp>}
 */
const methodInfo_TicketService_DeleteTicketEntrustRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DeleteTicketEntrustRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketEntrustRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DeleteTicketEntrustRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DeleteTicketEntrustRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.deleteTicketEntrustRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketEntrustRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketEntrustRule,
      callback);
};


/**
 * @param {!proto.xcommon.DeleteTicketEntrustRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DeleteTicketEntrustRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.deleteTicketEntrustRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketEntrustRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketEntrustRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketRecallParamReq,
 *   !proto.xcommon.GetTicketRecallParamResp>}
 */
const methodDescriptor_TicketService_GetTicketRecallParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketRecallParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketRecallParamReq,
  xcommon_ticket_pb.GetTicketRecallParamResp,
  /**
   * @param {!proto.xcommon.GetTicketRecallParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecallParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketRecallParamReq,
 *   !proto.xcommon.GetTicketRecallParamResp>}
 */
const methodInfo_TicketService_GetTicketRecallParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketRecallParamResp,
  /**
   * @param {!proto.xcommon.GetTicketRecallParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecallParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketRecallParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketRecallParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketRecallParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketRecallParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecallParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecallParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketRecallParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketRecallParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketRecallParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecallParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecallParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketRecallRulesReq,
 *   !proto.xcommon.GetTicketRecallRulesResp>}
 */
const methodDescriptor_TicketService_GetTicketRecallRules = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketRecallRules',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketRecallRulesReq,
  xcommon_ticket_pb.GetTicketRecallRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketRecallRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecallRulesResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketRecallRulesReq,
 *   !proto.xcommon.GetTicketRecallRulesResp>}
 */
const methodInfo_TicketService_GetTicketRecallRules = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketRecallRulesResp,
  /**
   * @param {!proto.xcommon.GetTicketRecallRulesReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketRecallRulesResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketRecallRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketRecallRulesResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketRecallRulesResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketRecallRules =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecallRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecallRules,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketRecallRulesReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketRecallRulesResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketRecallRules =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketRecallRules',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketRecallRules);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveTicketRecallRuleReq,
 *   !proto.xcommon.SaveTicketRecallRuleResp>}
 */
const methodDescriptor_TicketService_SaveTicketRecallRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveTicketRecallRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveTicketRecallRuleReq,
  xcommon_ticket_pb.SaveTicketRecallRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketRecallRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketRecallRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveTicketRecallRuleReq,
 *   !proto.xcommon.SaveTicketRecallRuleResp>}
 */
const methodInfo_TicketService_SaveTicketRecallRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveTicketRecallRuleResp,
  /**
   * @param {!proto.xcommon.SaveTicketRecallRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveTicketRecallRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveTicketRecallRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveTicketRecallRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveTicketRecallRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveTicketRecallRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketRecallRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketRecallRule,
      callback);
};


/**
 * @param {!proto.xcommon.SaveTicketRecallRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveTicketRecallRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveTicketRecallRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketRecallRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketRecallRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DeleteTicketRecallRuleReq,
 *   !proto.xcommon.DeleteTicketRecallRuleResp>}
 */
const methodDescriptor_TicketService_DeleteTicketRecallRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DeleteTicketRecallRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DeleteTicketRecallRuleReq,
  xcommon_ticket_pb.DeleteTicketRecallRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketRecallRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketRecallRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DeleteTicketRecallRuleReq,
 *   !proto.xcommon.DeleteTicketRecallRuleResp>}
 */
const methodInfo_TicketService_DeleteTicketRecallRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DeleteTicketRecallRuleResp,
  /**
   * @param {!proto.xcommon.DeleteTicketRecallRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DeleteTicketRecallRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DeleteTicketRecallRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DeleteTicketRecallRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DeleteTicketRecallRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.deleteTicketRecallRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketRecallRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketRecallRule,
      callback);
};


/**
 * @param {!proto.xcommon.DeleteTicketRecallRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DeleteTicketRecallRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.deleteTicketRecallRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DeleteTicketRecallRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_DeleteTicketRecallRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityOptionReq,
 *   !proto.xcommon.GetAudioQualityOptionResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityOption = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityOption',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityOptionReq,
  xcommon_ticket_pb.GetAudioQualityOptionResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityOptionResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityOptionReq,
 *   !proto.xcommon.GetAudioQualityOptionResp>}
 */
const methodInfo_TicketService_GetAudioQualityOption = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityOptionResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityOptionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityOptionResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityOptionResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityOptionResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityOption,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityOptionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityOptionResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityOption',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityScriptListReq,
 *   !proto.xcommon.GetAudioQualityScriptListResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityScriptList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityScriptList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityScriptListReq,
  xcommon_ticket_pb.GetAudioQualityScriptListResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityScriptListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityScriptListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityScriptListReq,
 *   !proto.xcommon.GetAudioQualityScriptListResp>}
 */
const methodInfo_TicketService_GetAudioQualityScriptList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityScriptListResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityScriptListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityScriptListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityScriptListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityScriptListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityScriptListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityScriptList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityScriptList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityScriptList,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityScriptListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityScriptListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityScriptList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityScriptList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityScriptList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityScriptReq,
 *   !proto.xcommon.GetAudioQualityScriptResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityScript = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityScript',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityScriptReq,
  xcommon_ticket_pb.GetAudioQualityScriptResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityScriptReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityScriptResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityScriptReq,
 *   !proto.xcommon.GetAudioQualityScriptResp>}
 */
const methodInfo_TicketService_GetAudioQualityScript = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityScriptResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityScriptReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityScriptResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityScriptReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityScriptResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityScriptResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityScript =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityScript',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityScript,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityScriptReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityScriptResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityScript =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityScript',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityScript);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveAudioQualityScriptReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_SaveAudioQualityScript = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveAudioQualityScript',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveAudioQualityScriptReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveAudioQualityScriptReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveAudioQualityScriptReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_SaveAudioQualityScript = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveAudioQualityScriptReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveAudioQualityScriptReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveAudioQualityScript =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveAudioQualityScript',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveAudioQualityScript,
      callback);
};


/**
 * @param {!proto.xcommon.SaveAudioQualityScriptReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveAudioQualityScript =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveAudioQualityScript',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveAudioQualityScript);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ModifyAudioQualityScriptStatusReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_ModifyAudioQualityScriptStatus = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ModifyAudioQualityScriptStatus',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ModifyAudioQualityScriptStatusReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ModifyAudioQualityScriptStatusReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_ModifyAudioQualityScriptStatus = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.modifyAudioQualityScriptStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyAudioQualityScriptStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyAudioQualityScriptStatus,
      callback);
};


/**
 * @param {!proto.xcommon.ModifyAudioQualityScriptStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.modifyAudioQualityScriptStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyAudioQualityScriptStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyAudioQualityScriptStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityRuleListReq,
 *   !proto.xcommon.GetAudioQualityRuleListResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityRuleList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityRuleList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityRuleListReq,
  xcommon_ticket_pb.GetAudioQualityRuleListResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityRuleListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityRuleListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityRuleListReq,
 *   !proto.xcommon.GetAudioQualityRuleListResp>}
 */
const methodInfo_TicketService_GetAudioQualityRuleList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityRuleListResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityRuleListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityRuleListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityRuleListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityRuleListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityRuleListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityRuleList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityRuleList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityRuleList,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityRuleListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityRuleListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityRuleList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityRuleList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityRuleList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityRuleReq,
 *   !proto.xcommon.GetAudioQualityRuleResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityRuleReq,
  xcommon_ticket_pb.GetAudioQualityRuleResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityRuleResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityRuleReq,
 *   !proto.xcommon.GetAudioQualityRuleResp>}
 */
const methodInfo_TicketService_GetAudioQualityRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityRuleResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityRuleResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityRuleResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityRuleResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityRule,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityRuleResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveAudioQualityRuleReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_SaveAudioQualityRule = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveAudioQualityRule',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveAudioQualityRuleReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveAudioQualityRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveAudioQualityRuleReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_SaveAudioQualityRule = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveAudioQualityRuleReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveAudioQualityRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveAudioQualityRule =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveAudioQualityRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveAudioQualityRule,
      callback);
};


/**
 * @param {!proto.xcommon.SaveAudioQualityRuleReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveAudioQualityRule =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveAudioQualityRule',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveAudioQualityRule);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ModifyAudioQualityRuleStatusReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_ModifyAudioQualityRuleStatus = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ModifyAudioQualityRuleStatus',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ModifyAudioQualityRuleStatusReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ModifyAudioQualityRuleStatusReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_ModifyAudioQualityRuleStatus = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.modifyAudioQualityRuleStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyAudioQualityRuleStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyAudioQualityRuleStatus,
      callback);
};


/**
 * @param {!proto.xcommon.ModifyAudioQualityRuleStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.modifyAudioQualityRuleStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyAudioQualityRuleStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyAudioQualityRuleStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityTplListReq,
 *   !proto.xcommon.GetAudioQualityTplListResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityTemplateList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityTemplateList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityTplListReq,
  xcommon_ticket_pb.GetAudioQualityTplListResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityTplListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityTplListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityTplListReq,
 *   !proto.xcommon.GetAudioQualityTplListResp>}
 */
const methodInfo_TicketService_GetAudioQualityTemplateList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityTplListResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityTplListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityTplListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityTplListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityTplListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityTplListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityTemplateList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityTemplateList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityTemplateList,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityTplListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityTplListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityTemplateList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityTemplateList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityTemplateList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAudioQualityTplReq,
 *   !proto.xcommon.GetAudioQualityTplResp>}
 */
const methodDescriptor_TicketService_GetAudioQualityTemplate = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAudioQualityTemplate',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAudioQualityTplReq,
  xcommon_ticket_pb.GetAudioQualityTplResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityTplReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityTplResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAudioQualityTplReq,
 *   !proto.xcommon.GetAudioQualityTplResp>}
 */
const methodInfo_TicketService_GetAudioQualityTemplate = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAudioQualityTplResp,
  /**
   * @param {!proto.xcommon.GetAudioQualityTplReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAudioQualityTplResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAudioQualityTplReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAudioQualityTplResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAudioQualityTplResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAudioQualityTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityTemplate',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityTemplate,
      callback);
};


/**
 * @param {!proto.xcommon.GetAudioQualityTplReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAudioQualityTplResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAudioQualityTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAudioQualityTemplate',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAudioQualityTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveAudioQualityTplReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_SaveAudioQualityTemplate = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveAudioQualityTemplate',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveAudioQualityTplReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveAudioQualityTplReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveAudioQualityTplReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_SaveAudioQualityTemplate = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveAudioQualityTplReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveAudioQualityTplReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveAudioQualityTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveAudioQualityTemplate',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveAudioQualityTemplate,
      callback);
};


/**
 * @param {!proto.xcommon.SaveAudioQualityTplReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveAudioQualityTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveAudioQualityTemplate',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveAudioQualityTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ModifyAudioQualityTemplateStatusReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_ModifyAudioQualityTemplateStatus = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ModifyAudioQualityTemplateStatus',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ModifyAudioQualityTemplateStatusReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ModifyAudioQualityTemplateStatusReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_ModifyAudioQualityTemplateStatus = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.modifyAudioQualityTemplateStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyAudioQualityTemplateStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyAudioQualityTemplateStatus,
      callback);
};


/**
 * @param {!proto.xcommon.ModifyAudioQualityTemplateStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.modifyAudioQualityTemplateStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyAudioQualityTemplateStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyAudioQualityTemplateStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ReAudioQualityReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_ReAudioQuality = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ReAudioQuality',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ReAudioQualityReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ReAudioQualityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ReAudioQualityReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_ReAudioQuality = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.ReAudioQualityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ReAudioQualityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.reAudioQuality =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ReAudioQuality',
      request,
      metadata || {},
      methodDescriptor_TicketService_ReAudioQuality,
      callback);
};


/**
 * @param {!proto.xcommon.ReAudioQualityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.reAudioQuality =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ReAudioQuality',
      request,
      metadata || {},
      methodDescriptor_TicketService_ReAudioQuality);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVerifyTicketListParamReq,
 *   !proto.xcommon.GetVerifyTicketListParamResp>}
 */
const methodDescriptor_TicketService_GetVerifyTicketListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetVerifyTicketListParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetVerifyTicketListParamReq,
  xcommon_ticket_pb.GetVerifyTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketListParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetVerifyTicketListParamReq,
 *   !proto.xcommon.GetVerifyTicketListParamResp>}
 */
const methodInfo_TicketService_GetVerifyTicketListParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetVerifyTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetVerifyTicketListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVerifyTicketListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getVerifyTicketListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetVerifyTicketListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVerifyTicketListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetVerifyTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVerifyTicketListParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getVerifyTicketListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetVerifyTicketListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVerifyTicketListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVerifyTicketListReq,
 *   !proto.xcommon.GetVerifyTicketListResp>}
 */
const methodDescriptor_TicketService_GetVerifyTicketList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetVerifyTicketList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetVerifyTicketListReq,
  xcommon_ticket_pb.GetVerifyTicketListResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetVerifyTicketListReq,
 *   !proto.xcommon.GetVerifyTicketListResp>}
 */
const methodInfo_TicketService_GetVerifyTicketList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetVerifyTicketListResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVerifyTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetVerifyTicketListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVerifyTicketListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getVerifyTicketList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetVerifyTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVerifyTicketList,
      callback);
};


/**
 * @param {!proto.xcommon.GetVerifyTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVerifyTicketListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getVerifyTicketList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetVerifyTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVerifyTicketList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVerifyTicketHandleTimeReq,
 *   !proto.xcommon.GetVerifyTicketHandleTimeResp>}
 */
const methodDescriptor_TicketService_GetVerifyTicketHandleTime = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetVerifyTicketHandleTime',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetVerifyTicketHandleTimeReq,
  xcommon_ticket_pb.GetVerifyTicketHandleTimeResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketHandleTimeResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetVerifyTicketHandleTimeReq,
 *   !proto.xcommon.GetVerifyTicketHandleTimeResp>}
 */
const methodInfo_TicketService_GetVerifyTicketHandleTime = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetVerifyTicketHandleTimeResp,
  /**
   * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVerifyTicketHandleTimeResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetVerifyTicketHandleTimeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVerifyTicketHandleTimeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getVerifyTicketHandleTime =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetVerifyTicketHandleTime',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVerifyTicketHandleTime,
      callback);
};


/**
 * @param {!proto.xcommon.GetVerifyTicketHandleTimeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVerifyTicketHandleTimeResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getVerifyTicketHandleTime =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetVerifyTicketHandleTime',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVerifyTicketHandleTime);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketListParamReq,
 *   !proto.xcommon.GetTicketListParamResp>}
 */
const methodDescriptor_TicketService_GetTicketListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketListParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketListParamReq,
  xcommon_ticket_pb.GetTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketListParamReq,
 *   !proto.xcommon.GetTicketListParamResp>}
 */
const methodInfo_TicketService_GetTicketListParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketListParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketListReq,
 *   !proto.xcommon.GetTicketListResp>}
 */
const methodDescriptor_TicketService_GetTicketList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketListReq,
  xcommon_ticket_pb.GetTicketListResp,
  /**
   * @param {!proto.xcommon.GetTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketListReq,
 *   !proto.xcommon.GetTicketListResp>}
 */
const methodInfo_TicketService_GetTicketList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketListResp,
  /**
   * @param {!proto.xcommon.GetTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketList,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.BatchAssignTicketReq,
 *   !proto.xcommon.BatchAssignTicketResp>}
 */
const methodDescriptor_TicketService_BatchAssignTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/BatchAssignTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.BatchAssignTicketReq,
  xcommon_ticket_pb.BatchAssignTicketResp,
  /**
   * @param {!proto.xcommon.BatchAssignTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchAssignTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.BatchAssignTicketReq,
 *   !proto.xcommon.BatchAssignTicketResp>}
 */
const methodInfo_TicketService_BatchAssignTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.BatchAssignTicketResp,
  /**
   * @param {!proto.xcommon.BatchAssignTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchAssignTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.BatchAssignTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.BatchAssignTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.BatchAssignTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.batchAssignTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/BatchAssignTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchAssignTicket,
      callback);
};


/**
 * @param {!proto.xcommon.BatchAssignTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.BatchAssignTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.batchAssignTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/BatchAssignTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchAssignTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.BatchRecycleTicketReq,
 *   !proto.xcommon.BatchRecycleTicketResp>}
 */
const methodDescriptor_TicketService_BatchRecycleTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/BatchRecycleTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.BatchRecycleTicketReq,
  xcommon_ticket_pb.BatchRecycleTicketResp,
  /**
   * @param {!proto.xcommon.BatchRecycleTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchRecycleTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.BatchRecycleTicketReq,
 *   !proto.xcommon.BatchRecycleTicketResp>}
 */
const methodInfo_TicketService_BatchRecycleTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.BatchRecycleTicketResp,
  /**
   * @param {!proto.xcommon.BatchRecycleTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchRecycleTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.BatchRecycleTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.BatchRecycleTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.BatchRecycleTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.batchRecycleTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/BatchRecycleTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchRecycleTicket,
      callback);
};


/**
 * @param {!proto.xcommon.BatchRecycleTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.BatchRecycleTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.batchRecycleTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/BatchRecycleTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchRecycleTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.BatchEntrustTicketReq,
 *   !proto.xcommon.BatchEntrustTicketResp>}
 */
const methodDescriptor_TicketService_BatchEntrustTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/BatchEntrustTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.BatchEntrustTicketReq,
  xcommon_ticket_pb.BatchEntrustTicketResp,
  /**
   * @param {!proto.xcommon.BatchEntrustTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchEntrustTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.BatchEntrustTicketReq,
 *   !proto.xcommon.BatchEntrustTicketResp>}
 */
const methodInfo_TicketService_BatchEntrustTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.BatchEntrustTicketResp,
  /**
   * @param {!proto.xcommon.BatchEntrustTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchEntrustTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.BatchEntrustTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.BatchEntrustTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.BatchEntrustTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.batchEntrustTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/BatchEntrustTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchEntrustTicket,
      callback);
};


/**
 * @param {!proto.xcommon.BatchEntrustTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.BatchEntrustTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.batchEntrustTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/BatchEntrustTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchEntrustTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.BatchRecallTicketReq,
 *   !proto.xcommon.BatchRecallTicketResp>}
 */
const methodDescriptor_TicketService_BatchRecallTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/BatchRecallTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.BatchRecallTicketReq,
  xcommon_ticket_pb.BatchRecallTicketResp,
  /**
   * @param {!proto.xcommon.BatchRecallTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchRecallTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.BatchRecallTicketReq,
 *   !proto.xcommon.BatchRecallTicketResp>}
 */
const methodInfo_TicketService_BatchRecallTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.BatchRecallTicketResp,
  /**
   * @param {!proto.xcommon.BatchRecallTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.BatchRecallTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.BatchRecallTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.BatchRecallTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.BatchRecallTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.batchRecallTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/BatchRecallTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchRecallTicket,
      callback);
};


/**
 * @param {!proto.xcommon.BatchRecallTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.BatchRecallTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.batchRecallTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/BatchRecallTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_BatchRecallTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ReduceTicketReq,
 *   !proto.xcommon.ReduceTicketResp>}
 */
const methodDescriptor_TicketService_ReduceTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ReduceTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ReduceTicketReq,
  xcommon_ticket_pb.ReduceTicketResp,
  /**
   * @param {!proto.xcommon.ReduceTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ReduceTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ReduceTicketReq,
 *   !proto.xcommon.ReduceTicketResp>}
 */
const methodInfo_TicketService_ReduceTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ReduceTicketResp,
  /**
   * @param {!proto.xcommon.ReduceTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ReduceTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ReduceTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ReduceTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ReduceTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.reduceTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ReduceTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_ReduceTicket,
      callback);
};


/**
 * @param {!proto.xcommon.ReduceTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ReduceTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.reduceTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ReduceTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_ReduceTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DoReducePrincipalReq,
 *   !proto.xcommon.DoReducePrincipalResp>}
 */
const methodDescriptor_TicketService_DoReducePrincipal = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DoReducePrincipal',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DoReducePrincipalReq,
  xcommon_ticket_pb.DoReducePrincipalResp,
  /**
   * @param {!proto.xcommon.DoReducePrincipalReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DoReducePrincipalResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DoReducePrincipalReq,
 *   !proto.xcommon.DoReducePrincipalResp>}
 */
const methodInfo_TicketService_DoReducePrincipal = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DoReducePrincipalResp,
  /**
   * @param {!proto.xcommon.DoReducePrincipalReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DoReducePrincipalResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DoReducePrincipalReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DoReducePrincipalResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DoReducePrincipalResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.doReducePrincipal =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DoReducePrincipal',
      request,
      metadata || {},
      methodDescriptor_TicketService_DoReducePrincipal,
      callback);
};


/**
 * @param {!proto.xcommon.DoReducePrincipalReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DoReducePrincipalResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.doReducePrincipal =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DoReducePrincipal',
      request,
      metadata || {},
      methodDescriptor_TicketService_DoReducePrincipal);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DoReduceOtherReq,
 *   !proto.xcommon.DoReduceOtherResp>}
 */
const methodDescriptor_TicketService_DoReduceOther = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DoReduceOther',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DoReduceOtherReq,
  xcommon_ticket_pb.DoReduceOtherResp,
  /**
   * @param {!proto.xcommon.DoReduceOtherReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DoReduceOtherResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DoReduceOtherReq,
 *   !proto.xcommon.DoReduceOtherResp>}
 */
const methodInfo_TicketService_DoReduceOther = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DoReduceOtherResp,
  /**
   * @param {!proto.xcommon.DoReduceOtherReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DoReduceOtherResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DoReduceOtherReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DoReduceOtherResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DoReduceOtherResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.doReduceOther =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DoReduceOther',
      request,
      metadata || {},
      methodDescriptor_TicketService_DoReduceOther,
      callback);
};


/**
 * @param {!proto.xcommon.DoReduceOtherReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DoReduceOtherResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.doReduceOther =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DoReduceOther',
      request,
      metadata || {},
      methodDescriptor_TicketService_DoReduceOther);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RollApplyTicketReq,
 *   !proto.xcommon.RollApplyTicketResp>}
 */
const methodDescriptor_TicketService_RollApplyTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/RollApplyTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.RollApplyTicketReq,
  xcommon_ticket_pb.RollApplyTicketResp,
  /**
   * @param {!proto.xcommon.RollApplyTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollApplyTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.RollApplyTicketReq,
 *   !proto.xcommon.RollApplyTicketResp>}
 */
const methodInfo_TicketService_RollApplyTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.RollApplyTicketResp,
  /**
   * @param {!proto.xcommon.RollApplyTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollApplyTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RollApplyTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.RollApplyTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RollApplyTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.rollApplyTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/RollApplyTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollApplyTicket,
      callback);
};


/**
 * @param {!proto.xcommon.RollApplyTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RollApplyTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.rollApplyTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/RollApplyTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollApplyTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.OpenTicketReq,
 *   !proto.xcommon.OpenTicketResp>}
 */
const methodDescriptor_TicketService_OpenTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/OpenTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.OpenTicketReq,
  xcommon_ticket_pb.OpenTicketResp,
  /**
   * @param {!proto.xcommon.OpenTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.OpenTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.OpenTicketReq,
 *   !proto.xcommon.OpenTicketResp>}
 */
const methodInfo_TicketService_OpenTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.OpenTicketResp,
  /**
   * @param {!proto.xcommon.OpenTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.OpenTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.OpenTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.OpenTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.OpenTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.openTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/OpenTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_OpenTicket,
      callback);
};


/**
 * @param {!proto.xcommon.OpenTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.OpenTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.openTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/OpenTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_OpenTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CloseTicketReq,
 *   !proto.xcommon.CloseTicketResp>}
 */
const methodDescriptor_TicketService_CloseTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/CloseTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CloseTicketReq,
  xcommon_ticket_pb.CloseTicketResp,
  /**
   * @param {!proto.xcommon.CloseTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CloseTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CloseTicketReq,
 *   !proto.xcommon.CloseTicketResp>}
 */
const methodInfo_TicketService_CloseTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CloseTicketResp,
  /**
   * @param {!proto.xcommon.CloseTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CloseTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CloseTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CloseTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CloseTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.closeTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/CloseTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_CloseTicket,
      callback);
};


/**
 * @param {!proto.xcommon.CloseTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CloseTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.closeTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/CloseTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_CloseTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SuspendTicketReq,
 *   !proto.xcommon.SuspendTicketResp>}
 */
const methodDescriptor_TicketService_SuspendTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SuspendTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SuspendTicketReq,
  xcommon_ticket_pb.SuspendTicketResp,
  /**
   * @param {!proto.xcommon.SuspendTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SuspendTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SuspendTicketReq,
 *   !proto.xcommon.SuspendTicketResp>}
 */
const methodInfo_TicketService_SuspendTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SuspendTicketResp,
  /**
   * @param {!proto.xcommon.SuspendTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SuspendTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SuspendTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SuspendTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SuspendTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.suspendTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SuspendTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_SuspendTicket,
      callback);
};


/**
 * @param {!proto.xcommon.SuspendTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SuspendTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.suspendTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SuspendTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_SuspendTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SuspendTicketReq,
 *   !proto.xcommon.SuspendTicketResp>}
 */
const methodDescriptor_TicketService_UnSuspendTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/UnSuspendTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SuspendTicketReq,
  xcommon_ticket_pb.SuspendTicketResp,
  /**
   * @param {!proto.xcommon.SuspendTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SuspendTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SuspendTicketReq,
 *   !proto.xcommon.SuspendTicketResp>}
 */
const methodInfo_TicketService_UnSuspendTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SuspendTicketResp,
  /**
   * @param {!proto.xcommon.SuspendTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SuspendTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SuspendTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SuspendTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SuspendTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.unSuspendTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/UnSuspendTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_UnSuspendTicket,
      callback);
};


/**
 * @param {!proto.xcommon.SuspendTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SuspendTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.unSuspendTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/UnSuspendTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_UnSuspendTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketEstimateReq,
 *   !proto.xcommon.GetTicketEstimateResp>}
 */
const methodDescriptor_TicketService_GetTicketEstimate = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketEstimate',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketEstimateReq,
  xcommon_ticket_pb.GetTicketEstimateResp,
  /**
   * @param {!proto.xcommon.GetTicketEstimateReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketEstimateResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketEstimateReq,
 *   !proto.xcommon.GetTicketEstimateResp>}
 */
const methodInfo_TicketService_GetTicketEstimate = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketEstimateResp,
  /**
   * @param {!proto.xcommon.GetTicketEstimateReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketEstimateResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketEstimateReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketEstimateResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketEstimateResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketEstimate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketEstimate',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketEstimate,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketEstimateReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketEstimateResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketEstimate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketEstimate',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketEstimate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetTicketListExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketListExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetTicketListExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketListExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketListExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketListExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketListExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketListExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketListExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketLogReq,
 *   !proto.xcommon.GetTicketLogResp>}
 */
const methodDescriptor_TicketService_GetTicketLog = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketLog',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketLogReq,
  xcommon_ticket_pb.GetTicketLogResp,
  /**
   * @param {!proto.xcommon.GetTicketLogReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketLogResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketLogReq,
 *   !proto.xcommon.GetTicketLogResp>}
 */
const methodInfo_TicketService_GetTicketLog = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketLogResp,
  /**
   * @param {!proto.xcommon.GetTicketLogReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketLogResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketLogReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketLogResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketLogResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketLog =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketLog',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketLog,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketLogReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketLogResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketLog =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketLog',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketLog);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRepayCodePageCondReq,
 *   !proto.xcommon.GetRepayCodePageCondResp>}
 */
const methodDescriptor_TicketService_GetRepayCodePageCond = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRepayCodePageCond',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRepayCodePageCondReq,
  xcommon_ticket_pb.GetRepayCodePageCondResp,
  /**
   * @param {!proto.xcommon.GetRepayCodePageCondReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepayCodePageCondResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRepayCodePageCondReq,
 *   !proto.xcommon.GetRepayCodePageCondResp>}
 */
const methodInfo_TicketService_GetRepayCodePageCond = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetRepayCodePageCondResp,
  /**
   * @param {!proto.xcommon.GetRepayCodePageCondReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepayCodePageCondResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRepayCodePageCondReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetRepayCodePageCondResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRepayCodePageCondResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRepayCodePageCond =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepayCodePageCond',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepayCodePageCond,
      callback);
};


/**
 * @param {!proto.xcommon.GetRepayCodePageCondReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRepayCodePageCondResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRepayCodePageCond =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepayCodePageCond',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepayCodePageCond);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRepayCodePageReq,
 *   !proto.xcommon.GetRepayCodePageResp>}
 */
const methodDescriptor_TicketService_GetRepayCodePage = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRepayCodePage',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRepayCodePageReq,
  xcommon_ticket_pb.GetRepayCodePageResp,
  /**
   * @param {!proto.xcommon.GetRepayCodePageReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepayCodePageResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRepayCodePageReq,
 *   !proto.xcommon.GetRepayCodePageResp>}
 */
const methodInfo_TicketService_GetRepayCodePage = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetRepayCodePageResp,
  /**
   * @param {!proto.xcommon.GetRepayCodePageReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepayCodePageResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRepayCodePageReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetRepayCodePageResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRepayCodePageResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRepayCodePage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepayCodePage',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepayCodePage,
      callback);
};


/**
 * @param {!proto.xcommon.GetRepayCodePageReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRepayCodePageResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRepayCodePage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepayCodePage',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepayCodePage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRepayCodeHistoryListReq,
 *   !proto.xcommon.GetRepayCodeHistoryListResp>}
 */
const methodDescriptor_TicketService_GetRepayCodeHistoryList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRepayCodeHistoryList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRepayCodeHistoryListReq,
  xcommon_ticket_pb.GetRepayCodeHistoryListResp,
  /**
   * @param {!proto.xcommon.GetRepayCodeHistoryListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepayCodeHistoryListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRepayCodeHistoryListReq,
 *   !proto.xcommon.GetRepayCodeHistoryListResp>}
 */
const methodInfo_TicketService_GetRepayCodeHistoryList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetRepayCodeHistoryListResp,
  /**
   * @param {!proto.xcommon.GetRepayCodeHistoryListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepayCodeHistoryListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRepayCodeHistoryListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetRepayCodeHistoryListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRepayCodeHistoryListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRepayCodeHistoryList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepayCodeHistoryList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepayCodeHistoryList,
      callback);
};


/**
 * @param {!proto.xcommon.GetRepayCodeHistoryListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRepayCodeHistoryListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRepayCodeHistoryList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepayCodeHistoryList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepayCodeHistoryList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AutoCallCoreReq,
 *   !proto.xcommon.AutoCallCoreResp>}
 */
const methodDescriptor_TicketService_GetAutoCallDetailResult = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAutoCallDetailResult',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.AutoCallCoreReq,
  xcommon_ticket_pb.AutoCallCoreResp,
  /**
   * @param {!proto.xcommon.AutoCallCoreReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AutoCallCoreResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.AutoCallCoreReq,
 *   !proto.xcommon.AutoCallCoreResp>}
 */
const methodInfo_TicketService_GetAutoCallDetailResult = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.AutoCallCoreResp,
  /**
   * @param {!proto.xcommon.AutoCallCoreReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AutoCallCoreResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.AutoCallCoreReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.AutoCallCoreResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.AutoCallCoreResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAutoCallDetailResult =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAutoCallDetailResult',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAutoCallDetailResult,
      callback);
};


/**
 * @param {!proto.xcommon.AutoCallCoreReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.AutoCallCoreResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAutoCallDetailResult =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAutoCallDetailResult',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAutoCallDetailResult);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ManualUpgradeTicketReq,
 *   !proto.xcommon.ManualUpgradeTicketResp>}
 */
const methodDescriptor_TicketService_ManualUpgradeTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ManualUpgradeTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ManualUpgradeTicketReq,
  xcommon_ticket_pb.ManualUpgradeTicketResp,
  /**
   * @param {!proto.xcommon.ManualUpgradeTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ManualUpgradeTicketResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ManualUpgradeTicketReq,
 *   !proto.xcommon.ManualUpgradeTicketResp>}
 */
const methodInfo_TicketService_ManualUpgradeTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ManualUpgradeTicketResp,
  /**
   * @param {!proto.xcommon.ManualUpgradeTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ManualUpgradeTicketResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ManualUpgradeTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ManualUpgradeTicketResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ManualUpgradeTicketResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.manualUpgradeTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ManualUpgradeTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_ManualUpgradeTicket,
      callback);
};


/**
 * @param {!proto.xcommon.ManualUpgradeTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ManualUpgradeTicketResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.manualUpgradeTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ManualUpgradeTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_ManualUpgradeTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ManualUpgradeTicketResultReq,
 *   !proto.xcommon.ManualUpgradeTicketResultResp>}
 */
const methodDescriptor_TicketService_ManualUpgradeTicketResult = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ManualUpgradeTicketResult',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ManualUpgradeTicketResultReq,
  xcommon_ticket_pb.ManualUpgradeTicketResultResp,
  /**
   * @param {!proto.xcommon.ManualUpgradeTicketResultReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ManualUpgradeTicketResultResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ManualUpgradeTicketResultReq,
 *   !proto.xcommon.ManualUpgradeTicketResultResp>}
 */
const methodInfo_TicketService_ManualUpgradeTicketResult = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ManualUpgradeTicketResultResp,
  /**
   * @param {!proto.xcommon.ManualUpgradeTicketResultReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ManualUpgradeTicketResultResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ManualUpgradeTicketResultReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ManualUpgradeTicketResultResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ManualUpgradeTicketResultResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.manualUpgradeTicketResult =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ManualUpgradeTicketResult',
      request,
      metadata || {},
      methodDescriptor_TicketService_ManualUpgradeTicketResult,
      callback);
};


/**
 * @param {!proto.xcommon.ManualUpgradeTicketResultReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ManualUpgradeTicketResultResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.manualUpgradeTicketResult =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ManualUpgradeTicketResult',
      request,
      metadata || {},
      methodDescriptor_TicketService_ManualUpgradeTicketResult);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetReduceListReq,
 *   !proto.xcommon.GetReduceListResp>}
 */
const methodDescriptor_TicketService_GetReduceList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetReduceList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetReduceListReq,
  xcommon_ticket_pb.GetReduceListResp,
  /**
   * @param {!proto.xcommon.GetReduceListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetReduceListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetReduceListReq,
 *   !proto.xcommon.GetReduceListResp>}
 */
const methodInfo_TicketService_GetReduceList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetReduceListResp,
  /**
   * @param {!proto.xcommon.GetReduceListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetReduceListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetReduceListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetReduceListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetReduceListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getReduceList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceList,
      callback);
};


/**
 * @param {!proto.xcommon.GetReduceListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetReduceListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getReduceList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetReduceDetailReq,
 *   !proto.xcommon.GetReduceDetailResp>}
 */
const methodDescriptor_TicketService_GetReduceDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetReduceDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetReduceDetailReq,
  xcommon_ticket_pb.GetReduceDetailResp,
  /**
   * @param {!proto.xcommon.GetReduceDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetReduceDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetReduceDetailReq,
 *   !proto.xcommon.GetReduceDetailResp>}
 */
const methodInfo_TicketService_GetReduceDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetReduceDetailResp,
  /**
   * @param {!proto.xcommon.GetReduceDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetReduceDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetReduceDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetReduceDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetReduceDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getReduceDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetReduceDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetReduceDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getReduceDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetReduceAuditListReq,
 *   !proto.xcommon.GetReduceAuditListResp>}
 */
const methodDescriptor_TicketService_GetReduceAuditList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetReduceAuditList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetReduceAuditListReq,
  xcommon_ticket_pb.GetReduceAuditListResp,
  /**
   * @param {!proto.xcommon.GetReduceAuditListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetReduceAuditListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetReduceAuditListReq,
 *   !proto.xcommon.GetReduceAuditListResp>}
 */
const methodInfo_TicketService_GetReduceAuditList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetReduceAuditListResp,
  /**
   * @param {!proto.xcommon.GetReduceAuditListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetReduceAuditListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetReduceAuditListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetReduceAuditListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetReduceAuditListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getReduceAuditList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceAuditList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceAuditList,
      callback);
};


/**
 * @param {!proto.xcommon.GetReduceAuditListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetReduceAuditListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getReduceAuditList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceAuditList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceAuditList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveReduceReq,
 *   !proto.xcommon.SaveReduceResp>}
 */
const methodDescriptor_TicketService_SaveReduce = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveReduce',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveReduceReq,
  xcommon_ticket_pb.SaveReduceResp,
  /**
   * @param {!proto.xcommon.SaveReduceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveReduceResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveReduceReq,
 *   !proto.xcommon.SaveReduceResp>}
 */
const methodInfo_TicketService_SaveReduce = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveReduceResp,
  /**
   * @param {!proto.xcommon.SaveReduceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveReduceResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveReduceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveReduceResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveReduceResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveReduce =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveReduce',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveReduce,
      callback);
};


/**
 * @param {!proto.xcommon.SaveReduceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveReduceResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveReduce =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveReduce',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveReduce);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetReduceListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetReduceListExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetReduceListExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetReduceListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetReduceListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetReduceListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetReduceListExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetReduceListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetReduceListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getReduceListExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceListExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceListExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetReduceListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getReduceListExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetReduceListExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetReduceListExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AssignTicketTrialCalcReq,
 *   !proto.xcommon.AssignTicketTrialCalcResp>}
 */
const methodDescriptor_TicketService_AssignTicketTrialCalc = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/AssignTicketTrialCalc',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.AssignTicketTrialCalcReq,
  xcommon_ticket_pb.AssignTicketTrialCalcResp,
  /**
   * @param {!proto.xcommon.AssignTicketTrialCalcReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AssignTicketTrialCalcResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.AssignTicketTrialCalcReq,
 *   !proto.xcommon.AssignTicketTrialCalcResp>}
 */
const methodInfo_TicketService_AssignTicketTrialCalc = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.AssignTicketTrialCalcResp,
  /**
   * @param {!proto.xcommon.AssignTicketTrialCalcReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AssignTicketTrialCalcResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.AssignTicketTrialCalcReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.AssignTicketTrialCalcResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.AssignTicketTrialCalcResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.assignTicketTrialCalc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/AssignTicketTrialCalc',
      request,
      metadata || {},
      methodDescriptor_TicketService_AssignTicketTrialCalc,
      callback);
};


/**
 * @param {!proto.xcommon.AssignTicketTrialCalcReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.AssignTicketTrialCalcResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.assignTicketTrialCalc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/AssignTicketTrialCalc',
      request,
      metadata || {},
      methodDescriptor_TicketService_AssignTicketTrialCalc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RollOrderTrialCalcReq,
 *   !proto.xcommon.RollOrderTrialCalcResp>}
 */
const methodDescriptor_TicketService_RollOrderTrialCalc = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/RollOrderTrialCalc',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.RollOrderTrialCalcReq,
  xcommon_ticket_pb.RollOrderTrialCalcResp,
  /**
   * @param {!proto.xcommon.RollOrderTrialCalcReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollOrderTrialCalcResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.RollOrderTrialCalcReq,
 *   !proto.xcommon.RollOrderTrialCalcResp>}
 */
const methodInfo_TicketService_RollOrderTrialCalc = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.RollOrderTrialCalcResp,
  /**
   * @param {!proto.xcommon.RollOrderTrialCalcReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollOrderTrialCalcResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RollOrderTrialCalcReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.RollOrderTrialCalcResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RollOrderTrialCalcResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.rollOrderTrialCalc =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/RollOrderTrialCalc',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollOrderTrialCalc,
      callback);
};


/**
 * @param {!proto.xcommon.RollOrderTrialCalcReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RollOrderTrialCalcResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.rollOrderTrialCalc =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/RollOrderTrialCalc',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollOrderTrialCalc);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RollOrderApplyReq,
 *   !proto.xcommon.RollOrderApplyResp>}
 */
const methodDescriptor_TicketService_RollOrderApply = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/RollOrderApply',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.RollOrderApplyReq,
  xcommon_ticket_pb.RollOrderApplyResp,
  /**
   * @param {!proto.xcommon.RollOrderApplyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollOrderApplyResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.RollOrderApplyReq,
 *   !proto.xcommon.RollOrderApplyResp>}
 */
const methodInfo_TicketService_RollOrderApply = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.RollOrderApplyResp,
  /**
   * @param {!proto.xcommon.RollOrderApplyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollOrderApplyResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RollOrderApplyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.RollOrderApplyResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RollOrderApplyResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.rollOrderApply =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/RollOrderApply',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollOrderApply,
      callback);
};


/**
 * @param {!proto.xcommon.RollOrderApplyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RollOrderApplyResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.rollOrderApply =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/RollOrderApply',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollOrderApply);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RollOrderCancelReq,
 *   !proto.xcommon.RollOrderCancelResp>}
 */
const methodDescriptor_TicketService_RollOrderCancel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/RollOrderCancel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.RollOrderCancelReq,
  xcommon_ticket_pb.RollOrderCancelResp,
  /**
   * @param {!proto.xcommon.RollOrderCancelReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollOrderCancelResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.RollOrderCancelReq,
 *   !proto.xcommon.RollOrderCancelResp>}
 */
const methodInfo_TicketService_RollOrderCancel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.RollOrderCancelResp,
  /**
   * @param {!proto.xcommon.RollOrderCancelReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RollOrderCancelResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RollOrderCancelReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.RollOrderCancelResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RollOrderCancelResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.rollOrderCancel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/RollOrderCancel',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollOrderCancel,
      callback);
};


/**
 * @param {!proto.xcommon.RollOrderCancelReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RollOrderCancelResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.rollOrderCancel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/RollOrderCancel',
      request,
      metadata || {},
      methodDescriptor_TicketService_RollOrderCancel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketCaseNameListReq,
 *   !proto.xcommon.GetTicketCaseNameListResp>}
 */
const methodDescriptor_TicketService_GetTicketCaseNameList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketCaseNameList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketCaseNameListReq,
  xcommon_ticket_pb.GetTicketCaseNameListResp,
  /**
   * @param {!proto.xcommon.GetTicketCaseNameListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketCaseNameListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketCaseNameListReq,
 *   !proto.xcommon.GetTicketCaseNameListResp>}
 */
const methodInfo_TicketService_GetTicketCaseNameList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketCaseNameListResp,
  /**
   * @param {!proto.xcommon.GetTicketCaseNameListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketCaseNameListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketCaseNameListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketCaseNameListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketCaseNameListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketCaseNameList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketCaseNameList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketCaseNameList,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketCaseNameListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketCaseNameListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketCaseNameList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketCaseNameList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketCaseNameList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketItemListReq,
 *   !proto.xcommon.GetTicketItemListResp>}
 */
const methodDescriptor_TicketService_GetTicketItemList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketItemList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketItemListReq,
  xcommon_ticket_pb.GetTicketItemListResp,
  /**
   * @param {!proto.xcommon.GetTicketItemListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketItemListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketItemListReq,
 *   !proto.xcommon.GetTicketItemListResp>}
 */
const methodInfo_TicketService_GetTicketItemList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketItemListResp,
  /**
   * @param {!proto.xcommon.GetTicketItemListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketItemListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketItemListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketItemListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketItemListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketItemList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketItemList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketItemList,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketItemListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketItemListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketItemList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketItemList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketItemList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveTicketItemsReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SaveTicketItems = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveTicketItems',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveTicketItemsReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.SaveTicketItemsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveTicketItemsReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SaveTicketItems = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.SaveTicketItemsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveTicketItemsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveTicketItems =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketItems',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketItems,
      callback);
};


/**
 * @param {!proto.xcommon.SaveTicketItemsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveTicketItems =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveTicketItems',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveTicketItems);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DelTicketItemReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_DelTicketItem = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DelTicketItem',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DelTicketItemReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.DelTicketItemReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DelTicketItemReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_DelTicketItem = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.DelTicketItemReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.DelTicketItemReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.delTicketItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DelTicketItem',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelTicketItem,
      callback);
};


/**
 * @param {!proto.xcommon.DelTicketItemReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.delTicketItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DelTicketItem',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelTicketItem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWorkerPerformanceReq,
 *   !proto.xcommon.GetWorkerPerformanceResp>}
 */
const methodDescriptor_TicketService_GetWorkerPerformance = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWorkerPerformance',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWorkerPerformanceReq,
  xcommon_ticket_pb.GetWorkerPerformanceResp,
  /**
   * @param {!proto.xcommon.GetWorkerPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWorkerPerformanceResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWorkerPerformanceReq,
 *   !proto.xcommon.GetWorkerPerformanceResp>}
 */
const methodInfo_TicketService_GetWorkerPerformance = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetWorkerPerformanceResp,
  /**
   * @param {!proto.xcommon.GetWorkerPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWorkerPerformanceResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWorkerPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetWorkerPerformanceResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWorkerPerformanceResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWorkerPerformance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerPerformance',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerPerformance,
      callback);
};


/**
 * @param {!proto.xcommon.GetWorkerPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWorkerPerformanceResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWorkerPerformance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerPerformance',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerPerformance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRolePerformanceReq,
 *   !proto.xcommon.GetRolePerformanceResp>}
 */
const methodDescriptor_TicketService_GetRolePerformance = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRolePerformance',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRolePerformanceReq,
  xcommon_ticket_pb.GetRolePerformanceResp,
  /**
   * @param {!proto.xcommon.GetRolePerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRolePerformanceResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRolePerformanceReq,
 *   !proto.xcommon.GetRolePerformanceResp>}
 */
const methodInfo_TicketService_GetRolePerformance = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetRolePerformanceResp,
  /**
   * @param {!proto.xcommon.GetRolePerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRolePerformanceResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRolePerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetRolePerformanceResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRolePerformanceResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRolePerformance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRolePerformance',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRolePerformance,
      callback);
};


/**
 * @param {!proto.xcommon.GetRolePerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRolePerformanceResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRolePerformance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRolePerformance',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRolePerformance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWorkerPerformanceReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetWorkerPerformanceExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWorkerPerformanceExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWorkerPerformanceReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetWorkerPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWorkerPerformanceReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetWorkerPerformanceExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetWorkerPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWorkerPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWorkerPerformanceExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerPerformanceExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerPerformanceExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetWorkerPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWorkerPerformanceExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerPerformanceExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerPerformanceExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRolePerformanceReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetRolePerformanceExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRolePerformanceExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRolePerformanceReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetRolePerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRolePerformanceReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetRolePerformanceExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetRolePerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRolePerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRolePerformanceExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRolePerformanceExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRolePerformanceExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetRolePerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRolePerformanceExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRolePerformanceExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRolePerformanceExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAppPerformanceReq,
 *   !proto.xcommon.GetAppPerformanceResp>}
 */
const methodDescriptor_TicketService_GetAppPerformance = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAppPerformance',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAppPerformanceReq,
  xcommon_ticket_pb.GetAppPerformanceResp,
  /**
   * @param {!proto.xcommon.GetAppPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAppPerformanceResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAppPerformanceReq,
 *   !proto.xcommon.GetAppPerformanceResp>}
 */
const methodInfo_TicketService_GetAppPerformance = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetAppPerformanceResp,
  /**
   * @param {!proto.xcommon.GetAppPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetAppPerformanceResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAppPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetAppPerformanceResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetAppPerformanceResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAppPerformance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAppPerformance',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAppPerformance,
      callback);
};


/**
 * @param {!proto.xcommon.GetAppPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetAppPerformanceResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAppPerformance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAppPerformance',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAppPerformance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetAppPerformanceReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetAppPerformanceExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetAppPerformanceExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetAppPerformanceReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetAppPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetAppPerformanceReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetAppPerformanceExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetAppPerformanceReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetAppPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getAppPerformanceExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetAppPerformanceExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAppPerformanceExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetAppPerformanceReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getAppPerformanceExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetAppPerformanceExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetAppPerformanceExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DashboardReq,
 *   !proto.xcommon.DashboardResp>}
 */
const methodDescriptor_TicketService_GetUrgeDashboard = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUrgeDashboard',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DashboardReq,
  xcommon_ticket_pb.DashboardResp,
  /**
   * @param {!proto.xcommon.DashboardReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DashboardResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DashboardReq,
 *   !proto.xcommon.DashboardResp>}
 */
const methodInfo_TicketService_GetUrgeDashboard = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DashboardResp,
  /**
   * @param {!proto.xcommon.DashboardReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DashboardResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DashboardReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DashboardResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DashboardResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUrgeDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeDashboard',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeDashboard,
      callback);
};


/**
 * @param {!proto.xcommon.DashboardReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DashboardResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUrgeDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeDashboard',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUrgeEfficiencyReq,
 *   !proto.xcommon.GetUrgeEfficiencyResp>}
 */
const methodDescriptor_TicketService_GetUrgeEfficiency = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUrgeEfficiency',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUrgeEfficiencyReq,
  xcommon_ticket_pb.GetUrgeEfficiencyResp,
  /**
   * @param {!proto.xcommon.GetUrgeEfficiencyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUrgeEfficiencyResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUrgeEfficiencyReq,
 *   !proto.xcommon.GetUrgeEfficiencyResp>}
 */
const methodInfo_TicketService_GetUrgeEfficiency = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetUrgeEfficiencyResp,
  /**
   * @param {!proto.xcommon.GetUrgeEfficiencyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUrgeEfficiencyResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetUrgeEfficiencyResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUrgeEfficiencyResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUrgeEfficiency =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeEfficiency',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeEfficiency,
      callback);
};


/**
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUrgeEfficiencyResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUrgeEfficiency =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeEfficiency',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeEfficiency);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUrgeFollowReq,
 *   !proto.xcommon.GetUrgeFollowResp>}
 */
const methodDescriptor_TicketService_GetUrgeFollow = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUrgeFollow',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUrgeFollowReq,
  xcommon_ticket_pb.GetUrgeFollowResp,
  /**
   * @param {!proto.xcommon.GetUrgeFollowReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUrgeFollowResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUrgeFollowReq,
 *   !proto.xcommon.GetUrgeFollowResp>}
 */
const methodInfo_TicketService_GetUrgeFollow = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetUrgeFollowResp,
  /**
   * @param {!proto.xcommon.GetUrgeFollowReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUrgeFollowResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUrgeFollowReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetUrgeFollowResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUrgeFollowResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUrgeFollow =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeFollow',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeFollow,
      callback);
};


/**
 * @param {!proto.xcommon.GetUrgeFollowReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUrgeFollowResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUrgeFollow =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeFollow',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeFollow);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUrgeEfficiencyReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetUrgeEfficiencyExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUrgeEfficiencyExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUrgeEfficiencyReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetUrgeEfficiencyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUrgeEfficiencyReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetUrgeEfficiencyExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetUrgeEfficiencyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUrgeEfficiencyExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeEfficiencyExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeEfficiencyExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetUrgeEfficiencyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUrgeEfficiencyExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeEfficiencyExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeEfficiencyExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUrgeFollowReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetUrgeFollowExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUrgeFollowExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUrgeFollowReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetUrgeFollowReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUrgeFollowReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetUrgeFollowExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetUrgeFollowReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUrgeFollowReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUrgeFollowExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeFollowExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeFollowExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetUrgeFollowReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUrgeFollowExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUrgeFollowExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUrgeFollowExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListUrgeDetailStatsReq,
 *   !proto.xcommon.ListUrgeDetailStatsResp>}
 */
const methodDescriptor_TicketService_ListUrgeDetailStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListUrgeDetailStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListUrgeDetailStatsReq,
  xcommon_ticket_pb.ListUrgeDetailStatsResp,
  /**
   * @param {!proto.xcommon.ListUrgeDetailStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListUrgeDetailStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListUrgeDetailStatsReq,
 *   !proto.xcommon.ListUrgeDetailStatsResp>}
 */
const methodInfo_TicketService_ListUrgeDetailStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListUrgeDetailStatsResp,
  /**
   * @param {!proto.xcommon.ListUrgeDetailStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListUrgeDetailStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListUrgeDetailStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListUrgeDetailStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listUrgeDetailStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListUrgeDetailStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListUrgeDetailStats,
      callback);
};


/**
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListUrgeDetailStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listUrgeDetailStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListUrgeDetailStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListUrgeDetailStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListUrgeDetailStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_ListUrgeDetailStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListUrgeDetailStatsExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListUrgeDetailStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListUrgeDetailStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListUrgeDetailStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_ListUrgeDetailStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListUrgeDetailStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listUrgeDetailStatsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListUrgeDetailStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListUrgeDetailStatsExcel,
      callback);
};


/**
 * @param {!proto.xcommon.ListUrgeDetailStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listUrgeDetailStatsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListUrgeDetailStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListUrgeDetailStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListUrgeDetailStatsParamReq,
 *   !proto.xcommon.ListUrgeDetailStatsParamResp>}
 */
const methodDescriptor_TicketService_ListUrgeDetailStatsParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListUrgeDetailStatsParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListUrgeDetailStatsParamReq,
  xcommon_ticket_pb.ListUrgeDetailStatsParamResp,
  /**
   * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListUrgeDetailStatsParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListUrgeDetailStatsParamReq,
 *   !proto.xcommon.ListUrgeDetailStatsParamResp>}
 */
const methodInfo_TicketService_ListUrgeDetailStatsParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListUrgeDetailStatsParamResp,
  /**
   * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListUrgeDetailStatsParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListUrgeDetailStatsParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListUrgeDetailStatsParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listUrgeDetailStatsParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListUrgeDetailStatsParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListUrgeDetailStatsParam,
      callback);
};


/**
 * @param {!proto.xcommon.ListUrgeDetailStatsParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListUrgeDetailStatsParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listUrgeDetailStatsParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListUrgeDetailStatsParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListUrgeDetailStatsParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.HourlyUrgeStatsReq,
 *   !proto.xcommon.HourlyUrgeStatsResp>}
 */
const methodDescriptor_TicketService_HourlyUrgeStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/HourlyUrgeStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.HourlyUrgeStatsReq,
  xcommon_ticket_pb.HourlyUrgeStatsResp,
  /**
   * @param {!proto.xcommon.HourlyUrgeStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.HourlyUrgeStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.HourlyUrgeStatsReq,
 *   !proto.xcommon.HourlyUrgeStatsResp>}
 */
const methodInfo_TicketService_HourlyUrgeStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.HourlyUrgeStatsResp,
  /**
   * @param {!proto.xcommon.HourlyUrgeStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.HourlyUrgeStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.HourlyUrgeStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.HourlyUrgeStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.HourlyUrgeStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.hourlyUrgeStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/HourlyUrgeStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_HourlyUrgeStats,
      callback);
};


/**
 * @param {!proto.xcommon.HourlyUrgeStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.HourlyUrgeStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.hourlyUrgeStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/HourlyUrgeStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_HourlyUrgeStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetHourlyCollectionStatsReq,
 *   !proto.xcommon.GetHourlyCollectionStatsResp>}
 */
const methodDescriptor_TicketService_GetHourlyCollectionStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetHourlyCollectionStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetHourlyCollectionStatsReq,
  xcommon_ticket_pb.GetHourlyCollectionStatsResp,
  /**
   * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetHourlyCollectionStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetHourlyCollectionStatsReq,
 *   !proto.xcommon.GetHourlyCollectionStatsResp>}
 */
const methodInfo_TicketService_GetHourlyCollectionStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetHourlyCollectionStatsResp,
  /**
   * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetHourlyCollectionStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetHourlyCollectionStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetHourlyCollectionStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getHourlyCollectionStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetHourlyCollectionStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetHourlyCollectionStats,
      callback);
};


/**
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetHourlyCollectionStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getHourlyCollectionStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetHourlyCollectionStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetHourlyCollectionStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetHourlyCollectionStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetHourlyCollectionStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetHourlyCollectionStatsExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetHourlyCollectionStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetHourlyCollectionStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetHourlyCollectionStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getHourlyCollectionStatsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetHourlyCollectionStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetHourlyCollectionStatsExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetHourlyCollectionStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getHourlyCollectionStatsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetHourlyCollectionStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetHourlyCollectionStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRepaymentDetailReq,
 *   !proto.xcommon.GetRepaymentDetailResp>}
 */
const methodDescriptor_TicketService_GetRepaymentDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRepaymentDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRepaymentDetailReq,
  xcommon_ticket_pb.GetRepaymentDetailResp,
  /**
   * @param {!proto.xcommon.GetRepaymentDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepaymentDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRepaymentDetailReq,
 *   !proto.xcommon.GetRepaymentDetailResp>}
 */
const methodInfo_TicketService_GetRepaymentDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetRepaymentDetailResp,
  /**
   * @param {!proto.xcommon.GetRepaymentDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRepaymentDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRepaymentDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetRepaymentDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRepaymentDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRepaymentDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepaymentDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepaymentDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetRepaymentDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRepaymentDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRepaymentDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRepaymentDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRepaymentDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWorkerRepayDetailReq,
 *   !proto.xcommon.GetWorkerRepayDetailResp>}
 */
const methodDescriptor_TicketService_GetWorkerRepayDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWorkerRepayDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWorkerRepayDetailReq,
  xcommon_ticket_pb.GetWorkerRepayDetailResp,
  /**
   * @param {!proto.xcommon.GetWorkerRepayDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWorkerRepayDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWorkerRepayDetailReq,
 *   !proto.xcommon.GetWorkerRepayDetailResp>}
 */
const methodInfo_TicketService_GetWorkerRepayDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetWorkerRepayDetailResp,
  /**
   * @param {!proto.xcommon.GetWorkerRepayDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWorkerRepayDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetWorkerRepayDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWorkerRepayDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWorkerRepayDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerRepayDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerRepayDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWorkerRepayDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWorkerRepayDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerRepayDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerRepayDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWorkerRepayDetailReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetWorkerRepayDetailExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWorkerRepayDetailExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWorkerRepayDetailReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetWorkerRepayDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWorkerRepayDetailReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetWorkerRepayDetailExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetWorkerRepayDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWorkerRepayDetailExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerRepayDetailExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerRepayDetailExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetWorkerRepayDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWorkerRepayDetailExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerRepayDetailExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerRepayDetailExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWorkerLoanUnpaidDetailReq,
 *   !proto.xcommon.GetWorkerLoanUnpaidDetailResp>}
 */
const methodDescriptor_TicketService_GetWorkerLoadUnpaidDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWorkerLoadUnpaidDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWorkerLoanUnpaidDetailReq,
  xcommon_ticket_pb.GetWorkerLoanUnpaidDetailResp,
  /**
   * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWorkerLoanUnpaidDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWorkerLoanUnpaidDetailReq,
 *   !proto.xcommon.GetWorkerLoanUnpaidDetailResp>}
 */
const methodInfo_TicketService_GetWorkerLoadUnpaidDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetWorkerLoanUnpaidDetailResp,
  /**
   * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWorkerLoanUnpaidDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetWorkerLoanUnpaidDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWorkerLoanUnpaidDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWorkerLoadUnpaidDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerLoadUnpaidDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerLoadUnpaidDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWorkerLoanUnpaidDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWorkerLoadUnpaidDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerLoadUnpaidDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerLoadUnpaidDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWorkerLoanUnpaidDetailReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetWorkerLoadUnpaidDetailExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWorkerLoadUnpaidDetailExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWorkerLoanUnpaidDetailReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWorkerLoanUnpaidDetailReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetWorkerLoadUnpaidDetailExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWorkerLoadUnpaidDetailExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerLoadUnpaidDetailExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerLoadUnpaidDetailExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetWorkerLoanUnpaidDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWorkerLoadUnpaidDetailExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWorkerLoadUnpaidDetailExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWorkerLoadUnpaidDetailExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOrderRepayDetailReq,
 *   !proto.xcommon.GetOrderRepayDetailResp>}
 */
const methodDescriptor_TicketService_GetOrderRepayDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetOrderRepayDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetOrderRepayDetailReq,
  xcommon_ticket_pb.GetOrderRepayDetailResp,
  /**
   * @param {!proto.xcommon.GetOrderRepayDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetOrderRepayDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetOrderRepayDetailReq,
 *   !proto.xcommon.GetOrderRepayDetailResp>}
 */
const methodInfo_TicketService_GetOrderRepayDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetOrderRepayDetailResp,
  /**
   * @param {!proto.xcommon.GetOrderRepayDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetOrderRepayDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOrderRepayDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetOrderRepayDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOrderRepayDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getOrderRepayDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetOrderRepayDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetOrderRepayDetail,
      callback);
};


/**
 * @param {!proto.xcommon.GetOrderRepayDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOrderRepayDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getOrderRepayDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetOrderRepayDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetOrderRepayDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetDialerListParamReq,
 *   !proto.xcommon.GetDialerListParamResp>}
 */
const methodDescriptor_TicketService_GetDialerListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetDialerListParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetDialerListParamReq,
  xcommon_ticket_pb.GetDialerListParamResp,
  /**
   * @param {!proto.xcommon.GetDialerListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetDialerListParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetDialerListParamReq,
 *   !proto.xcommon.GetDialerListParamResp>}
 */
const methodInfo_TicketService_GetDialerListParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetDialerListParamResp,
  /**
   * @param {!proto.xcommon.GetDialerListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetDialerListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetDialerListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetDialerListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetDialerListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getDialerListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetDialerListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetDialerListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetDialerListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetDialerListParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getDialerListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetDialerListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetDialerListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetDialerListReq,
 *   !proto.xcommon.GetDialerListResp>}
 */
const methodDescriptor_TicketService_GetDialerList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetDialerList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetDialerListReq,
  xcommon_ticket_pb.GetDialerListResp,
  /**
   * @param {!proto.xcommon.GetDialerListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetDialerListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetDialerListReq,
 *   !proto.xcommon.GetDialerListResp>}
 */
const methodInfo_TicketService_GetDialerList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetDialerListResp,
  /**
   * @param {!proto.xcommon.GetDialerListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetDialerListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetDialerListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetDialerListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetDialerListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getDialerList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetDialerList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetDialerList,
      callback);
};


/**
 * @param {!proto.xcommon.GetDialerListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetDialerListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getDialerList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetDialerList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetDialerList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveDialerReq,
 *   !proto.xcommon.SaveDialerResp>}
 */
const methodDescriptor_TicketService_SaveDialer = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveDialer',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveDialerReq,
  xcommon_ticket_pb.SaveDialerResp,
  /**
   * @param {!proto.xcommon.SaveDialerReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveDialerResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveDialerReq,
 *   !proto.xcommon.SaveDialerResp>}
 */
const methodInfo_TicketService_SaveDialer = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveDialerResp,
  /**
   * @param {!proto.xcommon.SaveDialerReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveDialerResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveDialerReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveDialerResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveDialerResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveDialer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveDialer',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveDialer,
      callback);
};


/**
 * @param {!proto.xcommon.SaveDialerReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveDialerResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveDialer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveDialer',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveDialer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetDialerListOrderReq,
 *   !proto.xcommon.GetDialerListOrderResp>}
 */
const methodDescriptor_TicketService_GetDialerListOrder = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetDialerListOrder',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetDialerListOrderReq,
  xcommon_ticket_pb.GetDialerListOrderResp,
  /**
   * @param {!proto.xcommon.GetDialerListOrderReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetDialerListOrderResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetDialerListOrderReq,
 *   !proto.xcommon.GetDialerListOrderResp>}
 */
const methodInfo_TicketService_GetDialerListOrder = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetDialerListOrderResp,
  /**
   * @param {!proto.xcommon.GetDialerListOrderReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetDialerListOrderResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetDialerListOrderReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetDialerListOrderResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetDialerListOrderResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getDialerListOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetDialerListOrder',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetDialerListOrder,
      callback);
};


/**
 * @param {!proto.xcommon.GetDialerListOrderReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetDialerListOrderResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getDialerListOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetDialerListOrder',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetDialerListOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveDialerListOrderReq,
 *   !proto.xcommon.SaveDialerListOrderResp>}
 */
const methodDescriptor_TicketService_SaveDialerListOrder = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveDialerListOrder',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveDialerListOrderReq,
  xcommon_ticket_pb.SaveDialerListOrderResp,
  /**
   * @param {!proto.xcommon.SaveDialerListOrderReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveDialerListOrderResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveDialerListOrderReq,
 *   !proto.xcommon.SaveDialerListOrderResp>}
 */
const methodInfo_TicketService_SaveDialerListOrder = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveDialerListOrderResp,
  /**
   * @param {!proto.xcommon.SaveDialerListOrderReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveDialerListOrderResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveDialerListOrderReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveDialerListOrderResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveDialerListOrderResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveDialerListOrder =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveDialerListOrder',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveDialerListOrder,
      callback);
};


/**
 * @param {!proto.xcommon.SaveDialerListOrderReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveDialerListOrderResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveDialerListOrder =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveDialerListOrder',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveDialerListOrder);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialerCurrentInfoReq,
 *   !proto.xcommon.DialerCurrentInfoResp>}
 */
const methodDescriptor_TicketService_DialerCurrentInfo = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DialerCurrentInfo',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DialerCurrentInfoReq,
  xcommon_ticket_pb.DialerCurrentInfoResp,
  /**
   * @param {!proto.xcommon.DialerCurrentInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerCurrentInfoResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DialerCurrentInfoReq,
 *   !proto.xcommon.DialerCurrentInfoResp>}
 */
const methodInfo_TicketService_DialerCurrentInfo = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DialerCurrentInfoResp,
  /**
   * @param {!proto.xcommon.DialerCurrentInfoReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerCurrentInfoResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialerCurrentInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DialerCurrentInfoResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialerCurrentInfoResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.dialerCurrentInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DialerCurrentInfo',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerCurrentInfo,
      callback);
};


/**
 * @param {!proto.xcommon.DialerCurrentInfoReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialerCurrentInfoResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.dialerCurrentInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DialerCurrentInfo',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerCurrentInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialerAutoStartReq,
 *   !proto.xcommon.DialerAutoStartResp>}
 */
const methodDescriptor_TicketService_DialerAutoStart = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DialerAutoStart',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DialerAutoStartReq,
  xcommon_ticket_pb.DialerAutoStartResp,
  /**
   * @param {!proto.xcommon.DialerAutoStartReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerAutoStartResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DialerAutoStartReq,
 *   !proto.xcommon.DialerAutoStartResp>}
 */
const methodInfo_TicketService_DialerAutoStart = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DialerAutoStartResp,
  /**
   * @param {!proto.xcommon.DialerAutoStartReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerAutoStartResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialerAutoStartReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DialerAutoStartResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialerAutoStartResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.dialerAutoStart =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DialerAutoStart',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerAutoStart,
      callback);
};


/**
 * @param {!proto.xcommon.DialerAutoStartReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialerAutoStartResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.dialerAutoStart =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DialerAutoStart',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerAutoStart);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialerAutoStopReq,
 *   !proto.xcommon.DialerAutoStopResp>}
 */
const methodDescriptor_TicketService_DialerAutoStop = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DialerAutoStop',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DialerAutoStopReq,
  xcommon_ticket_pb.DialerAutoStopResp,
  /**
   * @param {!proto.xcommon.DialerAutoStopReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerAutoStopResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DialerAutoStopReq,
 *   !proto.xcommon.DialerAutoStopResp>}
 */
const methodInfo_TicketService_DialerAutoStop = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DialerAutoStopResp,
  /**
   * @param {!proto.xcommon.DialerAutoStopReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerAutoStopResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialerAutoStopReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DialerAutoStopResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialerAutoStopResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.dialerAutoStop =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DialerAutoStop',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerAutoStop,
      callback);
};


/**
 * @param {!proto.xcommon.DialerAutoStopReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialerAutoStopResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.dialerAutoStop =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DialerAutoStop',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerAutoStop);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DialerAutoNextReq,
 *   !proto.xcommon.DialerAutoNextResp>}
 */
const methodDescriptor_TicketService_DialerAutoNext = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DialerAutoNext',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DialerAutoNextReq,
  xcommon_ticket_pb.DialerAutoNextResp,
  /**
   * @param {!proto.xcommon.DialerAutoNextReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerAutoNextResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DialerAutoNextReq,
 *   !proto.xcommon.DialerAutoNextResp>}
 */
const methodInfo_TicketService_DialerAutoNext = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DialerAutoNextResp,
  /**
   * @param {!proto.xcommon.DialerAutoNextReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DialerAutoNextResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DialerAutoNextReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DialerAutoNextResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DialerAutoNextResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.dialerAutoNext =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DialerAutoNext',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerAutoNext,
      callback);
};


/**
 * @param {!proto.xcommon.DialerAutoNextReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DialerAutoNextResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.dialerAutoNext =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DialerAutoNext',
      request,
      metadata || {},
      methodDescriptor_TicketService_DialerAutoNext);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionParameterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SaveQuestionParameter = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveQuestionParameter',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionParameterReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionParameterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionParameterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SaveQuestionParameter = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionParameterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionParameterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveQuestionParameter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestionParameter',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestionParameter,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionParameterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveQuestionParameter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestionParameter',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestionParameter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionParameterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_DelQuestionParameter = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DelQuestionParameter',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionParameterReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionParameterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionParameterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_DelQuestionParameter = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionParameterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionParameterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.delQuestionParameter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DelQuestionParameter',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelQuestionParameter,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionParameterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.delQuestionParameter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DelQuestionParameter',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelQuestionParameter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListQuestionParameterReq,
 *   !proto.xcommon.ListQuestionParameterResp>}
 */
const methodDescriptor_TicketService_ListQuestionParameter = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListQuestionParameter',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListQuestionParameterReq,
  xcommon_ticket_pb.ListQuestionParameterResp,
  /**
   * @param {!proto.xcommon.ListQuestionParameterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionParameterResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListQuestionParameterReq,
 *   !proto.xcommon.ListQuestionParameterResp>}
 */
const methodInfo_TicketService_ListQuestionParameter = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListQuestionParameterResp,
  /**
   * @param {!proto.xcommon.ListQuestionParameterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionParameterResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListQuestionParameterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListQuestionParameterResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListQuestionParameterResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listQuestionParameter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestionParameter',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestionParameter,
      callback);
};


/**
 * @param {!proto.xcommon.ListQuestionParameterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListQuestionParameterResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listQuestionParameter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestionParameter',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestionParameter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SaveQuestion = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveQuestion',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SaveQuestion = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestion,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_EditQuestion = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/EditQuestion',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_EditQuestion = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.editQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/EditQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_EditQuestion,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.editQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/EditQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_EditQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_DelQuestion = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DelQuestion',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_DelQuestion = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.delQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DelQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelQuestion,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.delQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DelQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListQuestionReq,
 *   !proto.xcommon.ListQuestionResp>}
 */
const methodDescriptor_TicketService_ListQuestion = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListQuestion',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListQuestionReq,
  xcommon_ticket_pb.ListQuestionResp,
  /**
   * @param {!proto.xcommon.ListQuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListQuestionReq,
 *   !proto.xcommon.ListQuestionResp>}
 */
const methodInfo_TicketService_ListQuestion = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListQuestionResp,
  /**
   * @param {!proto.xcommon.ListQuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListQuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListQuestionResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListQuestionResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestion,
      callback);
};


/**
 * @param {!proto.xcommon.ListQuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListQuestionResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionDisplayReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SaveQuestionDisplay = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveQuestionDisplay',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionDisplayReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionDisplayReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SaveQuestionDisplay = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveQuestionDisplay =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestionDisplay',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestionDisplay,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveQuestionDisplay =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestionDisplay',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestionDisplay);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionDisplayReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SaveQuestionDisplayCheck = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveQuestionDisplayCheck',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionDisplayReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionDisplayReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SaveQuestionDisplayCheck = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveQuestionDisplayCheck =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestionDisplayCheck',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestionDisplayCheck,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveQuestionDisplayCheck =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQuestionDisplayCheck',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQuestionDisplayCheck);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.QuestionDisplayReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_DelQuestionDisplay = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DelQuestionDisplay',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.QuestionDisplayReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.QuestionDisplayReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_DelQuestionDisplay = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.QuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.QuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.delQuestionDisplay =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DelQuestionDisplay',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelQuestionDisplay,
      callback);
};


/**
 * @param {!proto.xcommon.QuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.delQuestionDisplay =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DelQuestionDisplay',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelQuestionDisplay);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListQuestionDisplayReq,
 *   !proto.xcommon.ListQuestionDisplayResp>}
 */
const methodDescriptor_TicketService_ListQuestionDisplay = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListQuestionDisplay',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListQuestionDisplayReq,
  xcommon_ticket_pb.ListQuestionDisplayResp,
  /**
   * @param {!proto.xcommon.ListQuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionDisplayResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListQuestionDisplayReq,
 *   !proto.xcommon.ListQuestionDisplayResp>}
 */
const methodInfo_TicketService_ListQuestionDisplay = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListQuestionDisplayResp,
  /**
   * @param {!proto.xcommon.ListQuestionDisplayReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionDisplayResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListQuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListQuestionDisplayResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListQuestionDisplayResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listQuestionDisplay =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestionDisplay',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestionDisplay,
      callback);
};


/**
 * @param {!proto.xcommon.ListQuestionDisplayReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListQuestionDisplayResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listQuestionDisplay =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestionDisplay',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestionDisplay);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListQuestionAssociatedItemReq,
 *   !proto.xcommon.ListQuestionAssociatedItemResp>}
 */
const methodDescriptor_TicketService_ListQuestionAssociatedItem = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListQuestionAssociatedItem',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListQuestionAssociatedItemReq,
  xcommon_ticket_pb.ListQuestionAssociatedItemResp,
  /**
   * @param {!proto.xcommon.ListQuestionAssociatedItemReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionAssociatedItemResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListQuestionAssociatedItemReq,
 *   !proto.xcommon.ListQuestionAssociatedItemResp>}
 */
const methodInfo_TicketService_ListQuestionAssociatedItem = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListQuestionAssociatedItemResp,
  /**
   * @param {!proto.xcommon.ListQuestionAssociatedItemReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListQuestionAssociatedItemResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListQuestionAssociatedItemReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListQuestionAssociatedItemResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListQuestionAssociatedItemResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listQuestionAssociatedItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestionAssociatedItem',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestionAssociatedItem,
      callback);
};


/**
 * @param {!proto.xcommon.ListQuestionAssociatedItemReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListQuestionAssociatedItemResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listQuestionAssociatedItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListQuestionAssociatedItem',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListQuestionAssociatedItem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListVerifyQuestionReq,
 *   !proto.xcommon.ListVerifyQuestionResp>}
 */
const methodDescriptor_TicketService_ListVerifyQuestion = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListVerifyQuestion',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListVerifyQuestionReq,
  xcommon_ticket_pb.ListVerifyQuestionResp,
  /**
   * @param {!proto.xcommon.ListVerifyQuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListVerifyQuestionResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListVerifyQuestionReq,
 *   !proto.xcommon.ListVerifyQuestionResp>}
 */
const methodInfo_TicketService_ListVerifyQuestion = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListVerifyQuestionResp,
  /**
   * @param {!proto.xcommon.ListVerifyQuestionReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListVerifyQuestionResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListVerifyQuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListVerifyQuestionResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListVerifyQuestionResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listVerifyQuestion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListVerifyQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListVerifyQuestion,
      callback);
};


/**
 * @param {!proto.xcommon.ListVerifyQuestionReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListVerifyQuestionResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listVerifyQuestion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListVerifyQuestion',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListVerifyQuestion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SavePVRecordReq,
 *   !proto.xcommon.SavePVRecordResp>}
 */
const methodDescriptor_TicketService_SavePVRecord = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SavePVRecord',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SavePVRecordReq,
  xcommon_ticket_pb.SavePVRecordResp,
  /**
   * @param {!proto.xcommon.SavePVRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SavePVRecordResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SavePVRecordReq,
 *   !proto.xcommon.SavePVRecordResp>}
 */
const methodInfo_TicketService_SavePVRecord = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SavePVRecordResp,
  /**
   * @param {!proto.xcommon.SavePVRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SavePVRecordResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SavePVRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SavePVRecordResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SavePVRecordResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.savePVRecord =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SavePVRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_SavePVRecord,
      callback);
};


/**
 * @param {!proto.xcommon.SavePVRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SavePVRecordResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.savePVRecord =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SavePVRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_SavePVRecord);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetPVRecordReq,
 *   !proto.xcommon.GetPVRecordResp>}
 */
const methodDescriptor_TicketService_GetPVRecord = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetPVRecord',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetPVRecordReq,
  xcommon_ticket_pb.GetPVRecordResp,
  /**
   * @param {!proto.xcommon.GetPVRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetPVRecordResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetPVRecordReq,
 *   !proto.xcommon.GetPVRecordResp>}
 */
const methodInfo_TicketService_GetPVRecord = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetPVRecordResp,
  /**
   * @param {!proto.xcommon.GetPVRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetPVRecordResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetPVRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetPVRecordResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetPVRecordResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getPVRecord =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetPVRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetPVRecord,
      callback);
};


/**
 * @param {!proto.xcommon.GetPVRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetPVRecordResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getPVRecord =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetPVRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetPVRecord);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SavePVCallReq,
 *   !proto.xcommon.SavePVCallResp>}
 */
const methodDescriptor_TicketService_SavePVCallDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SavePVCallDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SavePVCallReq,
  xcommon_ticket_pb.SavePVCallResp,
  /**
   * @param {!proto.xcommon.SavePVCallReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SavePVCallResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SavePVCallReq,
 *   !proto.xcommon.SavePVCallResp>}
 */
const methodInfo_TicketService_SavePVCallDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SavePVCallResp,
  /**
   * @param {!proto.xcommon.SavePVCallReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SavePVCallResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SavePVCallReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SavePVCallResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SavePVCallResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.savePVCallDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SavePVCallDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_SavePVCallDetail,
      callback);
};


/**
 * @param {!proto.xcommon.SavePVCallReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SavePVCallResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.savePVCallDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SavePVCallDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_SavePVCallDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPVCallReq,
 *   !proto.xcommon.ListPVCallResp>}
 */
const methodDescriptor_TicketService_ListPVCallDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPVCallDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPVCallReq,
  xcommon_ticket_pb.ListPVCallResp,
  /**
   * @param {!proto.xcommon.ListPVCallReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPVCallResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPVCallReq,
 *   !proto.xcommon.ListPVCallResp>}
 */
const methodInfo_TicketService_ListPVCallDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPVCallResp,
  /**
   * @param {!proto.xcommon.ListPVCallReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPVCallResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPVCallReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPVCallResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPVCallResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPVCallDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPVCallDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPVCallDetail,
      callback);
};


/**
 * @param {!proto.xcommon.ListPVCallReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPVCallResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPVCallDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPVCallDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPVCallDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveQIRecordReq,
 *   !proto.xcommon.SaveQIRecordResp>}
 */
const methodDescriptor_TicketService_SaveQIRecord = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveQIRecord',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveQIRecordReq,
  xcommon_ticket_pb.SaveQIRecordResp,
  /**
   * @param {!proto.xcommon.SaveQIRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveQIRecordResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveQIRecordReq,
 *   !proto.xcommon.SaveQIRecordResp>}
 */
const methodInfo_TicketService_SaveQIRecord = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveQIRecordResp,
  /**
   * @param {!proto.xcommon.SaveQIRecordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveQIRecordResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveQIRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveQIRecordResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveQIRecordResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveQIRecord =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQIRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQIRecord,
      callback);
};


/**
 * @param {!proto.xcommon.SaveQIRecordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveQIRecordResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveQIRecord =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveQIRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveQIRecord);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CallingPlanReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodDescriptor_TicketService_CreateCallingPlan = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/CreateCallingPlan',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CallingPlanReq,
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.CallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CallingPlanReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodInfo_TicketService_CreateCallingPlan = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.CallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CallingPlanResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CallingPlanResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.createCallingPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/CreateCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateCallingPlan,
      callback);
};


/**
 * @param {!proto.xcommon.CallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CallingPlanResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.createCallingPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/CreateCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateCallingPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CallingPlanReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodDescriptor_TicketService_EditCallingPlan = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/EditCallingPlan',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CallingPlanReq,
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.CallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CallingPlanReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodInfo_TicketService_EditCallingPlan = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.CallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CallingPlanResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CallingPlanResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.editCallingPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/EditCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_EditCallingPlan,
      callback);
};


/**
 * @param {!proto.xcommon.CallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CallingPlanResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.editCallingPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/EditCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_EditCallingPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CallingPlanReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodDescriptor_TicketService_DelCallingPlan = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DelCallingPlan',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CallingPlanReq,
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.CallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CallingPlanReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodInfo_TicketService_DelCallingPlan = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.CallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CallingPlanResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CallingPlanResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.delCallingPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DelCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelCallingPlan,
      callback);
};


/**
 * @param {!proto.xcommon.CallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CallingPlanResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.delCallingPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DelCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelCallingPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListCallingPlanReq,
 *   !proto.xcommon.ListCallingPlanResp>}
 */
const methodDescriptor_TicketService_ListCallingPlan = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListCallingPlan',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListCallingPlanReq,
  xcommon_ticket_pb.ListCallingPlanResp,
  /**
   * @param {!proto.xcommon.ListCallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListCallingPlanResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListCallingPlanReq,
 *   !proto.xcommon.ListCallingPlanResp>}
 */
const methodInfo_TicketService_ListCallingPlan = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListCallingPlanResp,
  /**
   * @param {!proto.xcommon.ListCallingPlanReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListCallingPlanResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListCallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListCallingPlanResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListCallingPlanResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listCallingPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListCallingPlan,
      callback);
};


/**
 * @param {!proto.xcommon.ListCallingPlanReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListCallingPlanResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listCallingPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListCallingPlan',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListCallingPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.StopTaskReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodDescriptor_TicketService_StopCallingTask = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/StopCallingTask',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.StopTaskReq,
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.StopTaskReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.StopTaskReq,
 *   !proto.xcommon.CallingPlanResp>}
 */
const methodInfo_TicketService_StopCallingTask = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CallingPlanResp,
  /**
   * @param {!proto.xcommon.StopTaskReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CallingPlanResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.StopTaskReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CallingPlanResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CallingPlanResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.stopCallingTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/StopCallingTask',
      request,
      metadata || {},
      methodDescriptor_TicketService_StopCallingTask,
      callback);
};


/**
 * @param {!proto.xcommon.StopTaskReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CallingPlanResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.stopCallingTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/StopCallingTask',
      request,
      metadata || {},
      methodDescriptor_TicketService_StopCallingTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.RobotCallOutRecordListParamsReq,
 *   !proto.xcommon.RobotCallOutRecordListParamsResp>}
 */
const methodDescriptor_TicketService_GetRobotCallOutRecord = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRobotCallOutRecord',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.RobotCallOutRecordListParamsReq,
  xcommon_ticket_pb.RobotCallOutRecordListParamsResp,
  /**
   * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RobotCallOutRecordListParamsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.RobotCallOutRecordListParamsReq,
 *   !proto.xcommon.RobotCallOutRecordListParamsResp>}
 */
const methodInfo_TicketService_GetRobotCallOutRecord = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.RobotCallOutRecordListParamsResp,
  /**
   * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.RobotCallOutRecordListParamsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.RobotCallOutRecordListParamsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.RobotCallOutRecordListParamsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRobotCallOutRecord =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRobotCallOutRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRobotCallOutRecord,
      callback);
};


/**
 * @param {!proto.xcommon.RobotCallOutRecordListParamsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.RobotCallOutRecordListParamsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRobotCallOutRecord =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRobotCallOutRecord',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRobotCallOutRecord);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetCallingPlanConfigReq,
 *   !proto.xcommon.GetCallingPlanConfigResp>}
 */
const methodDescriptor_TicketService_GetCallingPlanConfig = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetCallingPlanConfig',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetCallingPlanConfigReq,
  xcommon_ticket_pb.GetCallingPlanConfigResp,
  /**
   * @param {!proto.xcommon.GetCallingPlanConfigReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetCallingPlanConfigResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetCallingPlanConfigReq,
 *   !proto.xcommon.GetCallingPlanConfigResp>}
 */
const methodInfo_TicketService_GetCallingPlanConfig = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetCallingPlanConfigResp,
  /**
   * @param {!proto.xcommon.GetCallingPlanConfigReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetCallingPlanConfigResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetCallingPlanConfigReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetCallingPlanConfigResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetCallingPlanConfigResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getCallingPlanConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetCallingPlanConfig',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetCallingPlanConfig,
      callback);
};


/**
 * @param {!proto.xcommon.GetCallingPlanConfigReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetCallingPlanConfigResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getCallingPlanConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetCallingPlanConfig',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetCallingPlanConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.LawyerLetterListReq,
 *   !proto.xcommon.LawyerLetterListResp>}
 */
const methodDescriptor_TicketService_GetLawyerLetterList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetLawyerLetterList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.LawyerLetterListReq,
  xcommon_ticket_pb.LawyerLetterListResp,
  /**
   * @param {!proto.xcommon.LawyerLetterListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.LawyerLetterListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.LawyerLetterListReq,
 *   !proto.xcommon.LawyerLetterListResp>}
 */
const methodInfo_TicketService_GetLawyerLetterList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.LawyerLetterListResp,
  /**
   * @param {!proto.xcommon.LawyerLetterListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.LawyerLetterListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.LawyerLetterListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.LawyerLetterListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.LawyerLetterListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getLawyerLetterList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetLawyerLetterList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLawyerLetterList,
      callback);
};


/**
 * @param {!proto.xcommon.LawyerLetterListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.LawyerLetterListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getLawyerLetterList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetLawyerLetterList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLawyerLetterList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.LawyerLetterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SaveLawyerLetter = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveLawyerLetter',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.LawyerLetterReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.LawyerLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.LawyerLetterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SaveLawyerLetter = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.LawyerLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.LawyerLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveLawyerLetter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveLawyerLetter',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveLawyerLetter,
      callback);
};


/**
 * @param {!proto.xcommon.LawyerLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveLawyerLetter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveLawyerLetter',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveLawyerLetter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.LawyerLetterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_ModifyLawyerLetterStatus = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ModifyLawyerLetterStatus',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.LawyerLetterReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.LawyerLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.LawyerLetterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_ModifyLawyerLetterStatus = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.LawyerLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.LawyerLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.modifyLawyerLetterStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyLawyerLetterStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyLawyerLetterStatus,
      callback);
};


/**
 * @param {!proto.xcommon.LawyerLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.modifyLawyerLetterStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ModifyLawyerLetterStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_ModifyLawyerLetterStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.LawyerLetterListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetLawyerLetterStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetLawyerLetterStatsExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.LawyerLetterListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.LawyerLetterListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.LawyerLetterListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetLawyerLetterStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.LawyerLetterListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.LawyerLetterListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getLawyerLetterStatsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetLawyerLetterStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLawyerLetterStatsExcel,
      callback);
};


/**
 * @param {!proto.xcommon.LawyerLetterListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getLawyerLetterStatsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetLawyerLetterStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetLawyerLetterStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WarningLetterListReq,
 *   !proto.xcommon.WarningLetterListResp>}
 */
const methodDescriptor_TicketService_GetWarningLetterList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWarningLetterList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WarningLetterListReq,
  xcommon_ticket_pb.WarningLetterListResp,
  /**
   * @param {!proto.xcommon.WarningLetterListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WarningLetterListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WarningLetterListReq,
 *   !proto.xcommon.WarningLetterListResp>}
 */
const methodInfo_TicketService_GetWarningLetterList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WarningLetterListResp,
  /**
   * @param {!proto.xcommon.WarningLetterListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WarningLetterListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WarningLetterListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WarningLetterListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WarningLetterListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWarningLetterList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWarningLetterList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWarningLetterList,
      callback);
};


/**
 * @param {!proto.xcommon.WarningLetterListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WarningLetterListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWarningLetterList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWarningLetterList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWarningLetterList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DownWarningLetterReq,
 *   !proto.xcommon.DownWarningLetterResp>}
 */
const methodDescriptor_TicketService_DownloadWarningLetter = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DownloadWarningLetter',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DownWarningLetterReq,
  xcommon_ticket_pb.DownWarningLetterResp,
  /**
   * @param {!proto.xcommon.DownWarningLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DownWarningLetterResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DownWarningLetterReq,
 *   !proto.xcommon.DownWarningLetterResp>}
 */
const methodInfo_TicketService_DownloadWarningLetter = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DownWarningLetterResp,
  /**
   * @param {!proto.xcommon.DownWarningLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DownWarningLetterResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DownWarningLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DownWarningLetterResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DownWarningLetterResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.downloadWarningLetter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DownloadWarningLetter',
      request,
      metadata || {},
      methodDescriptor_TicketService_DownloadWarningLetter,
      callback);
};


/**
 * @param {!proto.xcommon.DownWarningLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DownWarningLetterResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.downloadWarningLetter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DownloadWarningLetter',
      request,
      metadata || {},
      methodDescriptor_TicketService_DownloadWarningLetter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WarningLetterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_SendWarningLetter = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SendWarningLetter',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WarningLetterReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.WarningLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WarningLetterReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_SendWarningLetter = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.WarningLetterReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.WarningLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.sendWarningLetter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SendWarningLetter',
      request,
      metadata || {},
      methodDescriptor_TicketService_SendWarningLetter,
      callback);
};


/**
 * @param {!proto.xcommon.WarningLetterReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.sendWarningLetter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SendWarningLetter',
      request,
      metadata || {},
      methodDescriptor_TicketService_SendWarningLetter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetUserTicketLoadReq,
 *   !proto.xcommon.GetUserTicketLoadResp>}
 */
const methodDescriptor_TicketService_GetUserLoad = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetUserLoad',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetUserTicketLoadReq,
  xcommon_ticket_pb.GetUserTicketLoadResp,
  /**
   * @param {!proto.xcommon.GetUserTicketLoadReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserTicketLoadResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetUserTicketLoadReq,
 *   !proto.xcommon.GetUserTicketLoadResp>}
 */
const methodInfo_TicketService_GetUserLoad = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetUserTicketLoadResp,
  /**
   * @param {!proto.xcommon.GetUserTicketLoadReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetUserTicketLoadResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetUserTicketLoadReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetUserTicketLoadResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetUserTicketLoadResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getUserLoad =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserLoad',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserLoad,
      callback);
};


/**
 * @param {!proto.xcommon.GetUserTicketLoadReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetUserTicketLoadResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getUserLoad =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetUserLoad',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetUserLoad);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketListParamReq,
 *   !proto.xcommon.GetTicketListParamResp>}
 */
const methodDescriptor_TicketService_GetPsTicketListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetPsTicketListParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketListParamReq,
  xcommon_ticket_pb.GetTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketListParamReq,
 *   !proto.xcommon.GetTicketListParamResp>}
 */
const methodInfo_TicketService_GetPsTicketListParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketListParamResp,
  /**
   * @param {!proto.xcommon.GetTicketListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getPsTicketListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetPsTicketListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetPsTicketListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketListParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getPsTicketListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetPsTicketListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetPsTicketListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketListReq,
 *   !proto.xcommon.GetTicketListResp>}
 */
const methodDescriptor_TicketService_GetPsTicketList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetPsTicketList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketListReq,
  xcommon_ticket_pb.GetTicketListResp,
  /**
   * @param {!proto.xcommon.GetTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketListReq,
 *   !proto.xcommon.GetTicketListResp>}
 */
const methodInfo_TicketService_GetPsTicketList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketListResp,
  /**
   * @param {!proto.xcommon.GetTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getPsTicketList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetPsTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetPsTicketList,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getPsTicketList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetPsTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetPsTicketList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneSaleProductReq,
 *   !proto.xcommon.ListPhoneSaleProductResp>}
 */
const methodDescriptor_TicketService_ListPhoneSaleProduct = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneSaleProduct',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPhoneSaleProductReq,
  xcommon_ticket_pb.ListPhoneSaleProductResp,
  /**
   * @param {!proto.xcommon.ListPhoneSaleProductReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneSaleProductResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneSaleProductReq,
 *   !proto.xcommon.ListPhoneSaleProductResp>}
 */
const methodInfo_TicketService_ListPhoneSaleProduct = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPhoneSaleProductResp,
  /**
   * @param {!proto.xcommon.ListPhoneSaleProductReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneSaleProductResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneSaleProductReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPhoneSaleProductResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPhoneSaleProductResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneSaleProduct =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneSaleProduct',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneSaleProduct,
      callback);
};


/**
 * @param {!proto.xcommon.ListPhoneSaleProductReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPhoneSaleProductResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneSaleProduct =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneSaleProduct',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneSaleProduct);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketQuantityReq,
 *   !proto.xcommon.GetTicketQuantityResp>}
 */
const methodDescriptor_TicketService_GetTicketQuantity = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketQuantity',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketQuantityReq,
  xcommon_ticket_pb.GetTicketQuantityResp,
  /**
   * @param {!proto.xcommon.GetTicketQuantityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketQuantityResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketQuantityReq,
 *   !proto.xcommon.GetTicketQuantityResp>}
 */
const methodInfo_TicketService_GetTicketQuantity = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetTicketQuantityResp,
  /**
   * @param {!proto.xcommon.GetTicketQuantityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetTicketQuantityResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketQuantityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetTicketQuantityResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetTicketQuantityResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketQuantity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketQuantity',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketQuantity,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketQuantityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetTicketQuantityResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketQuantity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketQuantity',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketQuantity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetTicketQuantityReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetTicketQuantityExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetTicketQuantityExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetTicketQuantityReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetTicketQuantityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetTicketQuantityReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetTicketQuantityExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetTicketQuantityReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetTicketQuantityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getTicketQuantityExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketQuantityExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketQuantityExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetTicketQuantityReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getTicketQuantityExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetTicketQuantityExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetTicketQuantityExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SmsStatsReq,
 *   !proto.xcommon.SmsStatsResp>}
 */
const methodDescriptor_TicketService_SmsStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SmsStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SmsStatsReq,
  xcommon_ticket_pb.SmsStatsResp,
  /**
   * @param {!proto.xcommon.SmsStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SmsStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SmsStatsReq,
 *   !proto.xcommon.SmsStatsResp>}
 */
const methodInfo_TicketService_SmsStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SmsStatsResp,
  /**
   * @param {!proto.xcommon.SmsStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SmsStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SmsStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SmsStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SmsStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.smsStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SmsStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_SmsStats,
      callback);
};


/**
 * @param {!proto.xcommon.SmsStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SmsStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.smsStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SmsStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_SmsStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SmsStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_SmsStatsExport = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SmsStatsExport',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SmsStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.SmsStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SmsStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_SmsStatsExport = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.SmsStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.SmsStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.smsStatsExport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SmsStatsExport',
      request,
      metadata || {},
      methodDescriptor_TicketService_SmsStatsExport,
      callback);
};


/**
 * @param {!proto.xcommon.SmsStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.smsStatsExport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SmsStatsExport',
      request,
      metadata || {},
      methodDescriptor_TicketService_SmsStatsExport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CreateQualityInspectionVoipReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_CreateQualityInspectionVoip = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/CreateQualityInspectionVoip',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CreateQualityInspectionVoipReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CreateQualityInspectionVoipReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_CreateQualityInspectionVoip = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.createQualityInspectionVoip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/CreateQualityInspectionVoip',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateQualityInspectionVoip,
      callback);
};


/**
 * @param {!proto.xcommon.CreateQualityInspectionVoipReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.createQualityInspectionVoip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/CreateQualityInspectionVoip',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateQualityInspectionVoip);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVoipQITicketListReq,
 *   !proto.xcommon.GetVoipQITicketListResp>}
 */
const methodDescriptor_TicketService_GetVoipQITicketList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetVoipQITicketList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetVoipQITicketListReq,
  xcommon_ticket_pb.GetVoipQITicketListResp,
  /**
   * @param {!proto.xcommon.GetVoipQITicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVoipQITicketListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetVoipQITicketListReq,
 *   !proto.xcommon.GetVoipQITicketListResp>}
 */
const methodInfo_TicketService_GetVoipQITicketList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetVoipQITicketListResp,
  /**
   * @param {!proto.xcommon.GetVoipQITicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetVoipQITicketListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVoipQITicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetVoipQITicketListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetVoipQITicketListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getVoipQITicketList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetVoipQITicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVoipQITicketList,
      callback);
};


/**
 * @param {!proto.xcommon.GetVoipQITicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetVoipQITicketListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getVoipQITicketList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetVoipQITicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVoipQITicketList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetVoipQITicketListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_GetVoipQITicketListExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetVoipQITicketListExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetVoipQITicketListReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetVoipQITicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetVoipQITicketListReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_GetVoipQITicketListExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.GetVoipQITicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetVoipQITicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getVoipQITicketListExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetVoipQITicketListExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVoipQITicketListExcel,
      callback);
};


/**
 * @param {!proto.xcommon.GetVoipQITicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getVoipQITicketListExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetVoipQITicketListExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetVoipQITicketListExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CreateRobotCorpusMarkReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_CreateRobotCorpusMark = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/CreateRobotCorpusMark',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CreateRobotCorpusMarkReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateRobotCorpusMarkReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CreateRobotCorpusMarkReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_CreateRobotCorpusMark = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateRobotCorpusMarkReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.CreateRobotCorpusMarkReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.createRobotCorpusMark =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/CreateRobotCorpusMark',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateRobotCorpusMark,
      callback);
};


/**
 * @param {!proto.xcommon.CreateRobotCorpusMarkReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.createRobotCorpusMark =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/CreateRobotCorpusMark',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateRobotCorpusMark);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetRobotCorpusMarkListReq,
 *   !proto.xcommon.GetRobotCorpusMarkListResp>}
 */
const methodDescriptor_TicketService_GetRobotCorpusMarkList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetRobotCorpusMarkList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetRobotCorpusMarkListReq,
  xcommon_ticket_pb.GetRobotCorpusMarkListResp,
  /**
   * @param {!proto.xcommon.GetRobotCorpusMarkListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRobotCorpusMarkListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetRobotCorpusMarkListReq,
 *   !proto.xcommon.GetRobotCorpusMarkListResp>}
 */
const methodInfo_TicketService_GetRobotCorpusMarkList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetRobotCorpusMarkListResp,
  /**
   * @param {!proto.xcommon.GetRobotCorpusMarkListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetRobotCorpusMarkListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetRobotCorpusMarkListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetRobotCorpusMarkListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetRobotCorpusMarkListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getRobotCorpusMarkList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetRobotCorpusMarkList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRobotCorpusMarkList,
      callback);
};


/**
 * @param {!proto.xcommon.GetRobotCorpusMarkListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetRobotCorpusMarkListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getRobotCorpusMarkList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetRobotCorpusMarkList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetRobotCorpusMarkList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.OutSourceRepayStatsReq,
 *   !proto.xcommon.OutSourceRepayStatsResp>}
 */
const methodDescriptor_TicketService_OutSourceRepayStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/OutSourceRepayStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.OutSourceRepayStatsReq,
  xcommon_ticket_pb.OutSourceRepayStatsResp,
  /**
   * @param {!proto.xcommon.OutSourceRepayStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.OutSourceRepayStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.OutSourceRepayStatsReq,
 *   !proto.xcommon.OutSourceRepayStatsResp>}
 */
const methodInfo_TicketService_OutSourceRepayStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.OutSourceRepayStatsResp,
  /**
   * @param {!proto.xcommon.OutSourceRepayStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.OutSourceRepayStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.OutSourceRepayStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.OutSourceRepayStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.OutSourceRepayStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.outSourceRepayStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceRepayStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceRepayStats,
      callback);
};


/**
 * @param {!proto.xcommon.OutSourceRepayStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.OutSourceRepayStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.outSourceRepayStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceRepayStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceRepayStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.OutSourceRepayStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_OutSourceRepayStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/OutSourceRepayStatsExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.OutSourceRepayStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.OutSourceRepayStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.OutSourceRepayStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_OutSourceRepayStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.OutSourceRepayStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.OutSourceRepayStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.outSourceRepayStatsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceRepayStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceRepayStatsExcel,
      callback);
};


/**
 * @param {!proto.xcommon.OutSourceRepayStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.outSourceRepayStatsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceRepayStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceRepayStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.OutSourceStatsReq,
 *   !proto.xcommon.OutSourceStatsResp>}
 */
const methodDescriptor_TicketService_OutSourceStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/OutSourceStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.OutSourceStatsReq,
  xcommon_ticket_pb.OutSourceStatsResp,
  /**
   * @param {!proto.xcommon.OutSourceStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.OutSourceStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.OutSourceStatsReq,
 *   !proto.xcommon.OutSourceStatsResp>}
 */
const methodInfo_TicketService_OutSourceStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.OutSourceStatsResp,
  /**
   * @param {!proto.xcommon.OutSourceStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.OutSourceStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.OutSourceStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.OutSourceStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.OutSourceStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.outSourceStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceStats,
      callback);
};


/**
 * @param {!proto.xcommon.OutSourceStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.OutSourceStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.outSourceStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.OutSourceStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_OutSourceStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/OutSourceStatsExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.OutSourceStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.OutSourceStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.OutSourceStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_OutSourceStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.OutSourceStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.OutSourceStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.outSourceStatsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceStatsExcel,
      callback);
};


/**
 * @param {!proto.xcommon.OutSourceStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.outSourceStatsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/OutSourceStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_OutSourceStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneVerifyStatsReq,
 *   !proto.xcommon.ListPhoneVerifyStatsResp>}
 */
const methodDescriptor_TicketService_ListPhoneVerifyStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneVerifyStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPhoneVerifyStatsReq,
  xcommon_ticket_pb.ListPhoneVerifyStatsResp,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneVerifyStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneVerifyStatsReq,
 *   !proto.xcommon.ListPhoneVerifyStatsResp>}
 */
const methodInfo_TicketService_ListPhoneVerifyStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPhoneVerifyStatsResp,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneVerifyStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPhoneVerifyStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPhoneVerifyStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneVerifyStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyStats,
      callback);
};


/**
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPhoneVerifyStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneVerifyStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneVerifyStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_ListPhoneVerifyStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneVerifyStatsExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPhoneVerifyStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneVerifyStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_ListPhoneVerifyStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneVerifyStatsExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyStatsExcel,
      callback);
};


/**
 * @param {!proto.xcommon.ListPhoneVerifyStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneVerifyStatsExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneVerifyReasonStatReq,
 *   !proto.xcommon.ListPhoneVerifyReasonStatResp>}
 */
const methodDescriptor_TicketService_ListPhoneVerifyReasonStat = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneVerifyReasonStat',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPhoneVerifyReasonStatReq,
  xcommon_ticket_pb.ListPhoneVerifyReasonStatResp,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneVerifyReasonStatResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneVerifyReasonStatReq,
 *   !proto.xcommon.ListPhoneVerifyReasonStatResp>}
 */
const methodInfo_TicketService_ListPhoneVerifyReasonStat = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPhoneVerifyReasonStatResp,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneVerifyReasonStatResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPhoneVerifyReasonStatResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPhoneVerifyReasonStatResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneVerifyReasonStat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyReasonStat',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyReasonStat,
      callback);
};


/**
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPhoneVerifyReasonStatResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneVerifyReasonStat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyReasonStat',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyReasonStat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneVerifyReasonStatReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_ListPhoneVerifyReasonStatExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneVerifyReasonStatExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPhoneVerifyReasonStatReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneVerifyReasonStatReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_ListPhoneVerifyReasonStatExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneVerifyReasonStatExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyReasonStatExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyReasonStatExcel,
      callback);
};


/**
 * @param {!proto.xcommon.ListPhoneVerifyReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneVerifyReasonStatExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneVerifyReasonStatExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneVerifyReasonStatExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.PVDashboardReq,
 *   !proto.xcommon.PVDashboardResp>}
 */
const methodDescriptor_TicketService_PVDashboard = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/PVDashboard',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.PVDashboardReq,
  xcommon_ticket_pb.PVDashboardResp,
  /**
   * @param {!proto.xcommon.PVDashboardReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PVDashboardResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.PVDashboardReq,
 *   !proto.xcommon.PVDashboardResp>}
 */
const methodInfo_TicketService_PVDashboard = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.PVDashboardResp,
  /**
   * @param {!proto.xcommon.PVDashboardReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PVDashboardResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.PVDashboardReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.PVDashboardResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.PVDashboardResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.pVDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/PVDashboard',
      request,
      metadata || {},
      methodDescriptor_TicketService_PVDashboard,
      callback);
};


/**
 * @param {!proto.xcommon.PVDashboardReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.PVDashboardResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.pVDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/PVDashboard',
      request,
      metadata || {},
      methodDescriptor_TicketService_PVDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.PVGroupStatsReq,
 *   !proto.xcommon.PVGroupStatsResp>}
 */
const methodDescriptor_TicketService_PVGroupStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/PVGroupStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.PVGroupStatsReq,
  xcommon_ticket_pb.PVGroupStatsResp,
  /**
   * @param {!proto.xcommon.PVGroupStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PVGroupStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.PVGroupStatsReq,
 *   !proto.xcommon.PVGroupStatsResp>}
 */
const methodInfo_TicketService_PVGroupStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.PVGroupStatsResp,
  /**
   * @param {!proto.xcommon.PVGroupStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PVGroupStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.PVGroupStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.PVGroupStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.PVGroupStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.pVGroupStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/PVGroupStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_PVGroupStats,
      callback);
};


/**
 * @param {!proto.xcommon.PVGroupStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.PVGroupStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.pVGroupStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/PVGroupStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_PVGroupStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.PSDashboardReq,
 *   !proto.xcommon.PSDashboardResp>}
 */
const methodDescriptor_TicketService_PSDashboard = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/PSDashboard',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.PSDashboardReq,
  xcommon_ticket_pb.PSDashboardResp,
  /**
   * @param {!proto.xcommon.PSDashboardReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PSDashboardResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.PSDashboardReq,
 *   !proto.xcommon.PSDashboardResp>}
 */
const methodInfo_TicketService_PSDashboard = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.PSDashboardResp,
  /**
   * @param {!proto.xcommon.PSDashboardReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PSDashboardResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.PSDashboardReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.PSDashboardResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.PSDashboardResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.pSDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/PSDashboard',
      request,
      metadata || {},
      methodDescriptor_TicketService_PSDashboard,
      callback);
};


/**
 * @param {!proto.xcommon.PSDashboardReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.PSDashboardResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.pSDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/PSDashboard',
      request,
      metadata || {},
      methodDescriptor_TicketService_PSDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.PSGroupStatsReq,
 *   !proto.xcommon.PSGroupStatsResp>}
 */
const methodDescriptor_TicketService_PSGroupStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/PSGroupStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.PSGroupStatsReq,
  xcommon_ticket_pb.PSGroupStatsResp,
  /**
   * @param {!proto.xcommon.PSGroupStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PSGroupStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.PSGroupStatsReq,
 *   !proto.xcommon.PSGroupStatsResp>}
 */
const methodInfo_TicketService_PSGroupStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.PSGroupStatsResp,
  /**
   * @param {!proto.xcommon.PSGroupStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.PSGroupStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.PSGroupStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.PSGroupStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.PSGroupStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.pSGroupStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/PSGroupStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_PSGroupStats,
      callback);
};


/**
 * @param {!proto.xcommon.PSGroupStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.PSGroupStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.pSGroupStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/PSGroupStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_PSGroupStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneSaleStatsReq,
 *   !proto.xcommon.ListPhoneSaleStatsResp>}
 */
const methodDescriptor_TicketService_ListPhoneSaleStats = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneSaleStats',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPhoneSaleStatsReq,
  xcommon_ticket_pb.ListPhoneSaleStatsResp,
  /**
   * @param {!proto.xcommon.ListPhoneSaleStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneSaleStatsResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneSaleStatsReq,
 *   !proto.xcommon.ListPhoneSaleStatsResp>}
 */
const methodInfo_TicketService_ListPhoneSaleStats = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPhoneSaleStatsResp,
  /**
   * @param {!proto.xcommon.ListPhoneSaleStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPhoneSaleStatsResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPhoneSaleStatsResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPhoneSaleStatsResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneSaleStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneSaleStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneSaleStats,
      callback);
};


/**
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPhoneSaleStatsResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneSaleStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneSaleStats',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneSaleStats);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPhoneSaleStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_ListPhoneSaleStatsExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPhoneSaleStatsExcel',
  grpc.web.MethodType.SERVER_STREAMING,
  xcommon_ticket_pb.ListPhoneSaleStatsReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListPhoneSaleStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPhoneSaleStatsReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_ListPhoneSaleStatsExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.ListPhoneSaleStatsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPhoneSaleStatsExcel =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneSaleStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneSaleStatsExcel);
};


/**
 * @param {!proto.xcommon.ListPhoneSaleStatsReq} request The request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPhoneSaleStatsExcel =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/ticketepb.TicketService/ListPhoneSaleStatsExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPhoneSaleStatsExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WorkOrderStatisticReq,
 *   !proto.xcommon.WorkOrderStatisticResp>}
 */
const methodDescriptor_TicketService_WorkOrderStatistic = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WorkOrderStatistic',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WorkOrderStatisticReq,
  xcommon_ticket_pb.WorkOrderStatisticResp,
  /**
   * @param {!proto.xcommon.WorkOrderStatisticReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WorkOrderStatisticResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WorkOrderStatisticReq,
 *   !proto.xcommon.WorkOrderStatisticResp>}
 */
const methodInfo_TicketService_WorkOrderStatistic = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WorkOrderStatisticResp,
  /**
   * @param {!proto.xcommon.WorkOrderStatisticReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WorkOrderStatisticResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WorkOrderStatisticReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WorkOrderStatisticResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WorkOrderStatisticResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.workOrderStatistic =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOrderStatistic',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOrderStatistic,
      callback);
};


/**
 * @param {!proto.xcommon.WorkOrderStatisticReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WorkOrderStatisticResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.workOrderStatistic =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOrderStatistic',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOrderStatistic);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WorkOrderStatisticReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_WorkOrderStatisticExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WorkOrderStatisticExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WorkOrderStatisticReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.WorkOrderStatisticReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WorkOrderStatisticReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_WorkOrderStatisticExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.WorkOrderStatisticReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.WorkOrderStatisticReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.workOrderStatisticExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOrderStatisticExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOrderStatisticExcel,
      callback);
};


/**
 * @param {!proto.xcommon.WorkOrderStatisticReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.workOrderStatisticExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOrderStatisticExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOrderStatisticExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WorkOverdueReasonStatReq,
 *   !proto.xcommon.WorkOverdueReasonStatResp>}
 */
const methodDescriptor_TicketService_WorkOverdueReasonStat = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WorkOverdueReasonStat',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WorkOverdueReasonStatReq,
  xcommon_ticket_pb.WorkOverdueReasonStatResp,
  /**
   * @param {!proto.xcommon.WorkOverdueReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WorkOverdueReasonStatResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WorkOverdueReasonStatReq,
 *   !proto.xcommon.WorkOverdueReasonStatResp>}
 */
const methodInfo_TicketService_WorkOverdueReasonStat = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WorkOverdueReasonStatResp,
  /**
   * @param {!proto.xcommon.WorkOverdueReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WorkOverdueReasonStatResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WorkOverdueReasonStatResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WorkOverdueReasonStatResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.workOverdueReasonStat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOverdueReasonStat',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOverdueReasonStat,
      callback);
};


/**
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WorkOverdueReasonStatResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.workOverdueReasonStat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOverdueReasonStat',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOverdueReasonStat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WorkOverdueReasonStatReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodDescriptor_TicketService_WorkOverdueReasonStatExcel = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WorkOverdueReasonStatExcel',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WorkOverdueReasonStatReq,
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.WorkOverdueReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WorkOverdueReasonStatReq,
 *   !proto.xcommon.FileResponse>}
 */
const methodInfo_TicketService_WorkOverdueReasonStatExcel = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.FileResponse,
  /**
   * @param {!proto.xcommon.WorkOverdueReasonStatReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.FileResponse.deserializeBinary
);


/**
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.FileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.FileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.workOverdueReasonStatExcel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOverdueReasonStatExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOverdueReasonStatExcel,
      callback);
};


/**
 * @param {!proto.xcommon.WorkOverdueReasonStatReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.FileResponse>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.workOverdueReasonStatExcel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WorkOverdueReasonStatExcel',
      request,
      metadata || {},
      methodDescriptor_TicketService_WorkOverdueReasonStatExcel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CreateOcrMarkTicketReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_TicketService_CreateOcrMarkTicket = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/CreateOcrMarkTicket',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.CreateOcrMarkTicketReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateOcrMarkTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CreateOcrMarkTicketReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodInfo_TicketService_CreateOcrMarkTicket = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.xcommon.CreateOcrMarkTicketReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.xcommon.CreateOcrMarkTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.createOcrMarkTicket =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/CreateOcrMarkTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateOcrMarkTicket,
      callback);
};


/**
 * @param {!proto.xcommon.CreateOcrMarkTicketReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.createOcrMarkTicket =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/CreateOcrMarkTicket',
      request,
      metadata || {},
      methodDescriptor_TicketService_CreateOcrMarkTicket);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetOcrMarkTicketListReq,
 *   !proto.xcommon.GetOcrMarkTicketListResp>}
 */
const methodDescriptor_TicketService_GetOcrMarkTicketList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetOcrMarkTicketList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetOcrMarkTicketListReq,
  xcommon_ticket_pb.GetOcrMarkTicketListResp,
  /**
   * @param {!proto.xcommon.GetOcrMarkTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetOcrMarkTicketListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetOcrMarkTicketListReq,
 *   !proto.xcommon.GetOcrMarkTicketListResp>}
 */
const methodInfo_TicketService_GetOcrMarkTicketList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetOcrMarkTicketListResp,
  /**
   * @param {!proto.xcommon.GetOcrMarkTicketListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetOcrMarkTicketListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetOcrMarkTicketListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetOcrMarkTicketListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getOcrMarkTicketList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetOcrMarkTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetOcrMarkTicketList,
      callback);
};


/**
 * @param {!proto.xcommon.GetOcrMarkTicketListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetOcrMarkTicketListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getOcrMarkTicketList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetOcrMarkTicketList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetOcrMarkTicketList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WALoginStatusReq,
 *   !proto.xcommon.WALoginStatusResp>}
 */
const methodDescriptor_TicketService_WALoginStatus = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WALoginStatus',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WALoginStatusReq,
  xcommon_ticket_pb.WALoginStatusResp,
  /**
   * @param {!proto.xcommon.WALoginStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WALoginStatusResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WALoginStatusReq,
 *   !proto.xcommon.WALoginStatusResp>}
 */
const methodInfo_TicketService_WALoginStatus = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WALoginStatusResp,
  /**
   * @param {!proto.xcommon.WALoginStatusReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WALoginStatusResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WALoginStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WALoginStatusResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WALoginStatusResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wALoginStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WALoginStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_WALoginStatus,
      callback);
};


/**
 * @param {!proto.xcommon.WALoginStatusReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WALoginStatusResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wALoginStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WALoginStatus',
      request,
      metadata || {},
      methodDescriptor_TicketService_WALoginStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAGetQRCodeReq,
 *   !proto.xcommon.WAGetQRCodeResp>}
 */
const methodDescriptor_TicketService_WAGetQRCode = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WAGetQRCode',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAGetQRCodeReq,
  xcommon_ticket_pb.WAGetQRCodeResp,
  /**
   * @param {!proto.xcommon.WAGetQRCodeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetQRCodeResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAGetQRCodeReq,
 *   !proto.xcommon.WAGetQRCodeResp>}
 */
const methodInfo_TicketService_WAGetQRCode = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAGetQRCodeResp,
  /**
   * @param {!proto.xcommon.WAGetQRCodeReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetQRCodeResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAGetQRCodeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAGetQRCodeResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAGetQRCodeResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wAGetQRCode =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetQRCode',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetQRCode,
      callback);
};


/**
 * @param {!proto.xcommon.WAGetQRCodeReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAGetQRCodeResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wAGetQRCode =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetQRCode',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetQRCode);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WASendTextMsgReq,
 *   !proto.xcommon.WASendTextMsgResp>}
 */
const methodDescriptor_TicketService_WASendTextMsg = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WASendTextMsg',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WASendTextMsgReq,
  xcommon_ticket_pb.WASendTextMsgResp,
  /**
   * @param {!proto.xcommon.WASendTextMsgReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WASendTextMsgResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WASendTextMsgReq,
 *   !proto.xcommon.WASendTextMsgResp>}
 */
const methodInfo_TicketService_WASendTextMsg = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WASendTextMsgResp,
  /**
   * @param {!proto.xcommon.WASendTextMsgReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WASendTextMsgResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WASendTextMsgReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WASendTextMsgResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WASendTextMsgResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wASendTextMsg =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WASendTextMsg',
      request,
      metadata || {},
      methodDescriptor_TicketService_WASendTextMsg,
      callback);
};


/**
 * @param {!proto.xcommon.WASendTextMsgReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WASendTextMsgResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wASendTextMsg =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WASendTextMsg',
      request,
      metadata || {},
      methodDescriptor_TicketService_WASendTextMsg);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAMsgReadReq,
 *   !proto.xcommon.WAMsgReadResp>}
 */
const methodDescriptor_TicketService_WAMsgRead = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WAMsgRead',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAMsgReadReq,
  xcommon_ticket_pb.WAMsgReadResp,
  /**
   * @param {!proto.xcommon.WAMsgReadReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAMsgReadResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAMsgReadReq,
 *   !proto.xcommon.WAMsgReadResp>}
 */
const methodInfo_TicketService_WAMsgRead = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAMsgReadResp,
  /**
   * @param {!proto.xcommon.WAMsgReadReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAMsgReadResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAMsgReadReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAMsgReadResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAMsgReadResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wAMsgRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WAMsgRead',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAMsgRead,
      callback);
};


/**
 * @param {!proto.xcommon.WAMsgReadReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAMsgReadResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wAMsgRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WAMsgRead',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAMsgRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAGetMobileByUIDReq,
 *   !proto.xcommon.WAGetMobileByUIDResp>}
 */
const methodDescriptor_TicketService_WAGetMobileByUID = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WAGetMobileByUID',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAGetMobileByUIDReq,
  xcommon_ticket_pb.WAGetMobileByUIDResp,
  /**
   * @param {!proto.xcommon.WAGetMobileByUIDReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetMobileByUIDResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAGetMobileByUIDReq,
 *   !proto.xcommon.WAGetMobileByUIDResp>}
 */
const methodInfo_TicketService_WAGetMobileByUID = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAGetMobileByUIDResp,
  /**
   * @param {!proto.xcommon.WAGetMobileByUIDReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetMobileByUIDResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAGetMobileByUIDReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAGetMobileByUIDResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAGetMobileByUIDResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wAGetMobileByUID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetMobileByUID',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetMobileByUID,
      callback);
};


/**
 * @param {!proto.xcommon.WAGetMobileByUIDReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAGetMobileByUIDResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wAGetMobileByUID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetMobileByUID',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetMobileByUID);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAGetParamByUIDReq,
 *   !proto.xcommon.WAGetParamByUIDResp>}
 */
const methodDescriptor_TicketService_WAGetParamByUID = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WAGetParamByUID',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAGetParamByUIDReq,
  xcommon_ticket_pb.WAGetParamByUIDResp,
  /**
   * @param {!proto.xcommon.WAGetParamByUIDReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetParamByUIDResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAGetParamByUIDReq,
 *   !proto.xcommon.WAGetParamByUIDResp>}
 */
const methodInfo_TicketService_WAGetParamByUID = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAGetParamByUIDResp,
  /**
   * @param {!proto.xcommon.WAGetParamByUIDReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetParamByUIDResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAGetParamByUIDReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAGetParamByUIDResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAGetParamByUIDResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wAGetParamByUID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetParamByUID',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetParamByUID,
      callback);
};


/**
 * @param {!proto.xcommon.WAGetParamByUIDReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAGetParamByUIDResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wAGetParamByUID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetParamByUID',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetParamByUID);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAGetChatByMobileReq,
 *   !proto.xcommon.WAGetChatByMobileResp>}
 */
const methodDescriptor_TicketService_WAGetChatByMobile = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WAGetChatByMobile',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAGetChatByMobileReq,
  xcommon_ticket_pb.WAGetChatByMobileResp,
  /**
   * @param {!proto.xcommon.WAGetChatByMobileReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetChatByMobileResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAGetChatByMobileReq,
 *   !proto.xcommon.WAGetChatByMobileResp>}
 */
const methodInfo_TicketService_WAGetChatByMobile = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAGetChatByMobileResp,
  /**
   * @param {!proto.xcommon.WAGetChatByMobileReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetChatByMobileResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAGetChatByMobileReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAGetChatByMobileResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAGetChatByMobileResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wAGetChatByMobile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetChatByMobile',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetChatByMobile,
      callback);
};


/**
 * @param {!proto.xcommon.WAGetChatByMobileReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAGetChatByMobileResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wAGetChatByMobile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetChatByMobile',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetChatByMobile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAGetMsgByMobileReq,
 *   !proto.xcommon.WAGetMsgByMobileResp>}
 */
const methodDescriptor_TicketService_WAGetMsgByMobile = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/WAGetMsgByMobile',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAGetMsgByMobileReq,
  xcommon_ticket_pb.WAGetMsgByMobileResp,
  /**
   * @param {!proto.xcommon.WAGetMsgByMobileReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetMsgByMobileResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAGetMsgByMobileReq,
 *   !proto.xcommon.WAGetMsgByMobileResp>}
 */
const methodInfo_TicketService_WAGetMsgByMobile = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAGetMsgByMobileResp,
  /**
   * @param {!proto.xcommon.WAGetMsgByMobileReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAGetMsgByMobileResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAGetMsgByMobileReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAGetMsgByMobileResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAGetMsgByMobileResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.wAGetMsgByMobile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetMsgByMobile',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetMsgByMobile,
      callback);
};


/**
 * @param {!proto.xcommon.WAGetMsgByMobileReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAGetMsgByMobileResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.wAGetMsgByMobile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/WAGetMsgByMobile',
      request,
      metadata || {},
      methodDescriptor_TicketService_WAGetMsgByMobile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ImportWAPhoneReq,
 *   !proto.xcommon.ImportWAPhoneResp>}
 */
const methodDescriptor_TicketService_ImportWAPhone = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ImportWAPhone',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ImportWAPhoneReq,
  xcommon_ticket_pb.ImportWAPhoneResp,
  /**
   * @param {!proto.xcommon.ImportWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ImportWAPhoneResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ImportWAPhoneReq,
 *   !proto.xcommon.ImportWAPhoneResp>}
 */
const methodInfo_TicketService_ImportWAPhone = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ImportWAPhoneResp,
  /**
   * @param {!proto.xcommon.ImportWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ImportWAPhoneResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ImportWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ImportWAPhoneResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ImportWAPhoneResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.importWAPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ImportWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_ImportWAPhone,
      callback);
};


/**
 * @param {!proto.xcommon.ImportWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ImportWAPhoneResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.importWAPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ImportWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_ImportWAPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.WAListReq,
 *   !proto.xcommon.WAListResp>}
 */
const methodDescriptor_TicketService_GetWAList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWAList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.WAListReq,
  xcommon_ticket_pb.WAListResp,
  /**
   * @param {!proto.xcommon.WAListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.WAListReq,
 *   !proto.xcommon.WAListResp>}
 */
const methodInfo_TicketService_GetWAList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.WAListResp,
  /**
   * @param {!proto.xcommon.WAListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.WAListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.WAListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WAListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WAListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWAList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWAList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWAList,
      callback);
};


/**
 * @param {!proto.xcommon.WAListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WAListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWAList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWAList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWAList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AssignWAPhoneReq,
 *   !proto.xcommon.AssignWAPhoneResp>}
 */
const methodDescriptor_TicketService_AssignWAPhone = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/AssignWAPhone',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.AssignWAPhoneReq,
  xcommon_ticket_pb.AssignWAPhoneResp,
  /**
   * @param {!proto.xcommon.AssignWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AssignWAPhoneResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.AssignWAPhoneReq,
 *   !proto.xcommon.AssignWAPhoneResp>}
 */
const methodInfo_TicketService_AssignWAPhone = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.AssignWAPhoneResp,
  /**
   * @param {!proto.xcommon.AssignWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AssignWAPhoneResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.AssignWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.AssignWAPhoneResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.AssignWAPhoneResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.assignWAPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/AssignWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_AssignWAPhone,
      callback);
};


/**
 * @param {!proto.xcommon.AssignWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.AssignWAPhoneResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.assignWAPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/AssignWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_AssignWAPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.AssignWAPhoneReq,
 *   !proto.xcommon.AssignWAPhoneResp>}
 */
const methodDescriptor_TicketService_UnAssignWAPhone = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/UnAssignWAPhone',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.AssignWAPhoneReq,
  xcommon_ticket_pb.AssignWAPhoneResp,
  /**
   * @param {!proto.xcommon.AssignWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AssignWAPhoneResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.AssignWAPhoneReq,
 *   !proto.xcommon.AssignWAPhoneResp>}
 */
const methodInfo_TicketService_UnAssignWAPhone = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.AssignWAPhoneResp,
  /**
   * @param {!proto.xcommon.AssignWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.AssignWAPhoneResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.AssignWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.AssignWAPhoneResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.AssignWAPhoneResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.unAssignWAPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/UnAssignWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_UnAssignWAPhone,
      callback);
};


/**
 * @param {!proto.xcommon.AssignWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.AssignWAPhoneResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.unAssignWAPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/UnAssignWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_UnAssignWAPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.MarkWAPhoneReq,
 *   !proto.xcommon.MarkWAPhoneResp>}
 */
const methodDescriptor_TicketService_MarkWAPhone = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/MarkWAPhone',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.MarkWAPhoneReq,
  xcommon_ticket_pb.MarkWAPhoneResp,
  /**
   * @param {!proto.xcommon.MarkWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.MarkWAPhoneResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.MarkWAPhoneReq,
 *   !proto.xcommon.MarkWAPhoneResp>}
 */
const methodInfo_TicketService_MarkWAPhone = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.MarkWAPhoneResp,
  /**
   * @param {!proto.xcommon.MarkWAPhoneReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.MarkWAPhoneResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.MarkWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.MarkWAPhoneResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.MarkWAPhoneResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.markWAPhone =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/MarkWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_MarkWAPhone,
      callback);
};


/**
 * @param {!proto.xcommon.MarkWAPhoneReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.MarkWAPhoneResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.markWAPhone =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/MarkWAPhone',
      request,
      metadata || {},
      methodDescriptor_TicketService_MarkWAPhone);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWaKeywordListParamReq,
 *   !proto.xcommon.GetWaKeywordListParamResp>}
 */
const methodDescriptor_TicketService_GetWaKeywordListParam = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWaKeywordListParam',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWaKeywordListParamReq,
  xcommon_ticket_pb.GetWaKeywordListParamResp,
  /**
   * @param {!proto.xcommon.GetWaKeywordListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWaKeywordListParamResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWaKeywordListParamReq,
 *   !proto.xcommon.GetWaKeywordListParamResp>}
 */
const methodInfo_TicketService_GetWaKeywordListParam = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetWaKeywordListParamResp,
  /**
   * @param {!proto.xcommon.GetWaKeywordListParamReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWaKeywordListParamResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWaKeywordListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetWaKeywordListParamResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWaKeywordListParamResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWaKeywordListParam =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWaKeywordListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWaKeywordListParam,
      callback);
};


/**
 * @param {!proto.xcommon.GetWaKeywordListParamReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWaKeywordListParamResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWaKeywordListParam =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWaKeywordListParam',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWaKeywordListParam);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWaKeywordListReq,
 *   !proto.xcommon.GetWaKeywordListResp>}
 */
const methodDescriptor_TicketService_GetWaKeywordList = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWaKeywordList',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWaKeywordListReq,
  xcommon_ticket_pb.GetWaKeywordListResp,
  /**
   * @param {!proto.xcommon.GetWaKeywordListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWaKeywordListResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWaKeywordListReq,
 *   !proto.xcommon.GetWaKeywordListResp>}
 */
const methodInfo_TicketService_GetWaKeywordList = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetWaKeywordListResp,
  /**
   * @param {!proto.xcommon.GetWaKeywordListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWaKeywordListResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWaKeywordListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetWaKeywordListResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWaKeywordListResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWaKeywordList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWaKeywordList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWaKeywordList,
      callback);
};


/**
 * @param {!proto.xcommon.GetWaKeywordListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWaKeywordListResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWaKeywordList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWaKeywordList',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWaKeywordList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.GetWaKeywordReq,
 *   !proto.xcommon.GetWaKeywordResp>}
 */
const methodDescriptor_TicketService_GetWaKeyword = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/GetWaKeyword',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.GetWaKeywordReq,
  xcommon_ticket_pb.GetWaKeywordResp,
  /**
   * @param {!proto.xcommon.GetWaKeywordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWaKeywordResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.GetWaKeywordReq,
 *   !proto.xcommon.GetWaKeywordResp>}
 */
const methodInfo_TicketService_GetWaKeyword = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.GetWaKeywordResp,
  /**
   * @param {!proto.xcommon.GetWaKeywordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.GetWaKeywordResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.GetWaKeywordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.GetWaKeywordResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.GetWaKeywordResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.getWaKeyword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/GetWaKeyword',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWaKeyword,
      callback);
};


/**
 * @param {!proto.xcommon.GetWaKeywordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.GetWaKeywordResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.getWaKeyword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/GetWaKeyword',
      request,
      metadata || {},
      methodDescriptor_TicketService_GetWaKeyword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveWaKeywordReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodDescriptor_TicketService_SaveWaKeyword = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveWaKeyword',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveWaKeywordReq,
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveWaKeywordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveWaKeywordReq,
 *   !proto.xcommon.CommonOutResp>}
 */
const methodInfo_TicketService_SaveWaKeyword = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.CommonOutResp,
  /**
   * @param {!proto.xcommon.SaveWaKeywordReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.CommonOutResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveWaKeywordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.CommonOutResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOutResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveWaKeyword =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveWaKeyword',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveWaKeyword,
      callback);
};


/**
 * @param {!proto.xcommon.SaveWaKeywordReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOutResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveWaKeyword =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveWaKeyword',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveWaKeyword);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveMultilingualReq,
 *   !proto.xcommon.SaveMultilingualResp>}
 */
const methodDescriptor_TicketService_SaveMultilingual = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveMultilingual',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveMultilingualReq,
  xcommon_ticket_pb.SaveMultilingualResp,
  /**
   * @param {!proto.xcommon.SaveMultilingualReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveMultilingualResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveMultilingualReq,
 *   !proto.xcommon.SaveMultilingualResp>}
 */
const methodInfo_TicketService_SaveMultilingual = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveMultilingualResp,
  /**
   * @param {!proto.xcommon.SaveMultilingualReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveMultilingualResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveMultilingualReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveMultilingualResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveMultilingualResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveMultilingual =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveMultilingual',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveMultilingual,
      callback);
};


/**
 * @param {!proto.xcommon.SaveMultilingualReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveMultilingualResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveMultilingual =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveMultilingual',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveMultilingual);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListMultilingualReq,
 *   !proto.xcommon.ListMultilingualResp>}
 */
const methodDescriptor_TicketService_ListMultilingual = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListMultilingual',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListMultilingualReq,
  xcommon_ticket_pb.ListMultilingualResp,
  /**
   * @param {!proto.xcommon.ListMultilingualReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListMultilingualResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListMultilingualReq,
 *   !proto.xcommon.ListMultilingualResp>}
 */
const methodInfo_TicketService_ListMultilingual = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListMultilingualResp,
  /**
   * @param {!proto.xcommon.ListMultilingualReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListMultilingualResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListMultilingualReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListMultilingualResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListMultilingualResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listMultilingual =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListMultilingual',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListMultilingual,
      callback);
};


/**
 * @param {!proto.xcommon.ListMultilingualReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListMultilingualResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listMultilingual =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListMultilingual',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListMultilingual);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SaveMultilingualDetailReq,
 *   !proto.xcommon.SaveMultilingualDetailResp>}
 */
const methodDescriptor_TicketService_SaveMultilingualDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SaveMultilingualDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SaveMultilingualDetailReq,
  xcommon_ticket_pb.SaveMultilingualDetailResp,
  /**
   * @param {!proto.xcommon.SaveMultilingualDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveMultilingualDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SaveMultilingualDetailReq,
 *   !proto.xcommon.SaveMultilingualDetailResp>}
 */
const methodInfo_TicketService_SaveMultilingualDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SaveMultilingualDetailResp,
  /**
   * @param {!proto.xcommon.SaveMultilingualDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SaveMultilingualDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SaveMultilingualDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SaveMultilingualDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SaveMultilingualDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.saveMultilingualDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SaveMultilingualDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveMultilingualDetail,
      callback);
};


/**
 * @param {!proto.xcommon.SaveMultilingualDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SaveMultilingualDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.saveMultilingualDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SaveMultilingualDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_SaveMultilingualDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.DelMultilingualDetailReq,
 *   !proto.xcommon.DelMultilingualDetailResp>}
 */
const methodDescriptor_TicketService_DelMultilingualDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/DelMultilingualDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.DelMultilingualDetailReq,
  xcommon_ticket_pb.DelMultilingualDetailResp,
  /**
   * @param {!proto.xcommon.DelMultilingualDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DelMultilingualDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.DelMultilingualDetailReq,
 *   !proto.xcommon.DelMultilingualDetailResp>}
 */
const methodInfo_TicketService_DelMultilingualDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.DelMultilingualDetailResp,
  /**
   * @param {!proto.xcommon.DelMultilingualDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.DelMultilingualDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.DelMultilingualDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.DelMultilingualDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.DelMultilingualDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.delMultilingualDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/DelMultilingualDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelMultilingualDetail,
      callback);
};


/**
 * @param {!proto.xcommon.DelMultilingualDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.DelMultilingualDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.delMultilingualDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/DelMultilingualDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_DelMultilingualDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListMultilingualDetailReq,
 *   !proto.xcommon.ListMultilingualDetailResp>}
 */
const methodDescriptor_TicketService_ListMultilingualDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListMultilingualDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListMultilingualDetailReq,
  xcommon_ticket_pb.ListMultilingualDetailResp,
  /**
   * @param {!proto.xcommon.ListMultilingualDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListMultilingualDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListMultilingualDetailReq,
 *   !proto.xcommon.ListMultilingualDetailResp>}
 */
const methodInfo_TicketService_ListMultilingualDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListMultilingualDetailResp,
  /**
   * @param {!proto.xcommon.ListMultilingualDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListMultilingualDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListMultilingualDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListMultilingualDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListMultilingualDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listMultilingualDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListMultilingualDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListMultilingualDetail,
      callback);
};


/**
 * @param {!proto.xcommon.ListMultilingualDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListMultilingualDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listMultilingualDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListMultilingualDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListMultilingualDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPushTemplateReq,
 *   !proto.xcommon.ListPushTemplateResp>}
 */
const methodDescriptor_TicketService_ListPushTemplate = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPushTemplate',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPushTemplateReq,
  xcommon_ticket_pb.ListPushTemplateResp,
  /**
   * @param {!proto.xcommon.ListPushTemplateReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPushTemplateResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPushTemplateReq,
 *   !proto.xcommon.ListPushTemplateResp>}
 */
const methodInfo_TicketService_ListPushTemplate = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPushTemplateResp,
  /**
   * @param {!proto.xcommon.ListPushTemplateReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPushTemplateResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPushTemplateReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPushTemplateResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPushTemplateResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPushTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPushTemplate',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPushTemplate,
      callback);
};


/**
 * @param {!proto.xcommon.ListPushTemplateReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPushTemplateResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPushTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPushTemplate',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPushTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.SavePushTaskReq,
 *   !proto.xcommon.SavePushTaskResp>}
 */
const methodDescriptor_TicketService_SavePushTask = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/SavePushTask',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.SavePushTaskReq,
  xcommon_ticket_pb.SavePushTaskResp,
  /**
   * @param {!proto.xcommon.SavePushTaskReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SavePushTaskResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.SavePushTaskReq,
 *   !proto.xcommon.SavePushTaskResp>}
 */
const methodInfo_TicketService_SavePushTask = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.SavePushTaskResp,
  /**
   * @param {!proto.xcommon.SavePushTaskReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.SavePushTaskResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.SavePushTaskReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.SavePushTaskResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.SavePushTaskResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.savePushTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/SavePushTask',
      request,
      metadata || {},
      methodDescriptor_TicketService_SavePushTask,
      callback);
};


/**
 * @param {!proto.xcommon.SavePushTaskReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.SavePushTaskResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.savePushTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/SavePushTask',
      request,
      metadata || {},
      methodDescriptor_TicketService_SavePushTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPushTaskReq,
 *   !proto.xcommon.ListPushTaskResp>}
 */
const methodDescriptor_TicketService_ListPushTask = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPushTask',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPushTaskReq,
  xcommon_ticket_pb.ListPushTaskResp,
  /**
   * @param {!proto.xcommon.ListPushTaskReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPushTaskResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPushTaskReq,
 *   !proto.xcommon.ListPushTaskResp>}
 */
const methodInfo_TicketService_ListPushTask = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPushTaskResp,
  /**
   * @param {!proto.xcommon.ListPushTaskReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPushTaskResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPushTaskReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPushTaskResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPushTaskResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPushTask =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPushTask',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPushTask,
      callback);
};


/**
 * @param {!proto.xcommon.ListPushTaskReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPushTaskResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPushTask =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPushTask',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPushTask);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ListPushDetailReq,
 *   !proto.xcommon.ListPushDetailResp>}
 */
const methodDescriptor_TicketService_ListPushDetail = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ListPushDetail',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ListPushDetailReq,
  xcommon_ticket_pb.ListPushDetailResp,
  /**
   * @param {!proto.xcommon.ListPushDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPushDetailResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ListPushDetailReq,
 *   !proto.xcommon.ListPushDetailResp>}
 */
const methodInfo_TicketService_ListPushDetail = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ListPushDetailResp,
  /**
   * @param {!proto.xcommon.ListPushDetailReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ListPushDetailResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ListPushDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ListPushDetailResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ListPushDetailResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.listPushDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ListPushDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPushDetail,
      callback);
};


/**
 * @param {!proto.xcommon.ListPushDetailReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ListPushDetailResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.listPushDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ListPushDetail',
      request,
      metadata || {},
      methodDescriptor_TicketService_ListPushDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.CommonCollaborationNotifyReq,
 *   !proto.xcommon.WebSocketNotifyResp>}
 */
const methodDescriptor_TicketService_CommonCollaborationNotify = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/CommonCollaborationNotify',
  grpc.web.MethodType.UNARY,
  xcommon_collection_pb.CommonCollaborationNotifyReq,
  xcommon_collection_pb.WebSocketNotifyResp,
  /**
   * @param {!proto.xcommon.CommonCollaborationNotifyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.WebSocketNotifyResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.CommonCollaborationNotifyReq,
 *   !proto.xcommon.WebSocketNotifyResp>}
 */
const methodInfo_TicketService_CommonCollaborationNotify = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_collection_pb.WebSocketNotifyResp,
  /**
   * @param {!proto.xcommon.CommonCollaborationNotifyReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_collection_pb.WebSocketNotifyResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.CommonCollaborationNotifyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.WebSocketNotifyResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.WebSocketNotifyResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.commonCollaborationNotify =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/CommonCollaborationNotify',
      request,
      metadata || {},
      methodDescriptor_TicketService_CommonCollaborationNotify,
      callback);
};


/**
 * @param {!proto.xcommon.CommonCollaborationNotifyReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.WebSocketNotifyResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.commonCollaborationNotify =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/CommonCollaborationNotify',
      request,
      metadata || {},
      methodDescriptor_TicketService_CommonCollaborationNotify);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.xcommon.ExportTicketEmailCSVReq,
 *   !proto.xcommon.ExportTicketEmailCSVResp>}
 */
const methodDescriptor_TicketService_ExportTicketEmailCSV = new grpc.web.MethodDescriptor(
  '/ticketepb.TicketService/ExportTicketEmailCSV',
  grpc.web.MethodType.UNARY,
  xcommon_ticket_pb.ExportTicketEmailCSVReq,
  xcommon_ticket_pb.ExportTicketEmailCSVResp,
  /**
   * @param {!proto.xcommon.ExportTicketEmailCSVReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ExportTicketEmailCSVResp.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.xcommon.ExportTicketEmailCSVReq,
 *   !proto.xcommon.ExportTicketEmailCSVResp>}
 */
const methodInfo_TicketService_ExportTicketEmailCSV = new grpc.web.AbstractClientBase.MethodInfo(
  xcommon_ticket_pb.ExportTicketEmailCSVResp,
  /**
   * @param {!proto.xcommon.ExportTicketEmailCSVReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_ticket_pb.ExportTicketEmailCSVResp.deserializeBinary
);


/**
 * @param {!proto.xcommon.ExportTicketEmailCSVReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.xcommon.ExportTicketEmailCSVResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.ExportTicketEmailCSVResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.ticketepb.TicketServiceClient.prototype.exportTicketEmailCSV =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/ticketepb.TicketService/ExportTicketEmailCSV',
      request,
      metadata || {},
      methodDescriptor_TicketService_ExportTicketEmailCSV,
      callback);
};


/**
 * @param {!proto.xcommon.ExportTicketEmailCSVReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.ExportTicketEmailCSVResp>}
 *     A native promise that resolves to the response
 */
proto.ticketepb.TicketServicePromiseClient.prototype.exportTicketEmailCSV =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/ticketepb.TicketService/ExportTicketEmailCSV',
      request,
      metadata || {},
      methodDescriptor_TicketService_ExportTicketEmailCSV);
};


module.exports = proto.ticketepb;

